<template>
  <div class="k-page-content adver">
    <el-tabs v-model="activeName" class="box-eltab">
      <el-tab-pane label="广告投放" name="first">
        <div class="k-page-common">
          <div class="k-common-con">
            <div class="content-expand">
              <div class="expand-config">
                <div class="expand-title">
                  <span>
                    配置区
                    <span style="margin-left:30px">
                      <el-link
                        style="font-size: 10px;"
                        type="primary"
                        :underline="false"
                        @click="changeMedia"
                      >切换媒体</el-link>
                    </span>
                  </span>
                  <div class="panel-header-right-wrapper">
                    <div class="account-count-info-wrapper">
                      <div class="ad-formula">
                        <div class="ad-formula-item">
                          <span
                            class="ad-formula-item__value"
                          >{{targetingList.targetingView.length}}</span>
                          <span class="ad-formula-item__label">定向包</span>
                        </div>
                        <div class="ad-formula-sign">x</div>
                        <div class="ad-formula-item">
                          <span class="ad-formula-item__value">{{creativeList.length}}</span>
                          <span class="ad-formula-item__label">创意组</span>
                        </div>
                        <template v-if="promotion_way == 'STANDARD'">
                          <div class="ad-formula-sign">x</div>
                          <div class="ad-formula-item">
                            <span class="ad-formula-item__value">{{tagList.length}}</span>
                            <span class="ad-formula-item__label">标签宝</span>
                          </div>
                        </template>
                        <div class="ad-formula-sign">=</div>
                        <div class="ad-formula-item">
                          <span class="ad-formula-item__value color--primary">{{totalNum}}</span>
                          <span class="ad-formula-item__label">广告计划</span>
                        </div>
                      </div>
                      <div class="collapse-icon">
                        <i class="el-icon-caret-bottom" @click="containerHide"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="expand-container" :class="{'expand-container-show':containerShow}">
                  <div class="setting-head">
                    <div class="filter-selectors">
                      <div class="selector">
                        <div class="k-select-area">
                          <label>营销目标:</label>
                          <el-select
                            v-model="marketing_goal"
                            placeholder="请选择营销目标"
                            :size="size"
                            clearable
                          >
                            <el-option
                              v-for="item in marketing_goal_options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </div>
                      </div>
                      <div class="selector">
                        <div class="k-select-area">
                          <label>推广方式:</label>
                          <el-select
                            v-model="promotion_way"
                            placeholder="请选择推广方式"
                            :size="size"
                            clearable
                          >
                            <el-option
                              v-for="item in promotion_way_options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </div>
                      </div>
                      <div class="selector">
                        <div class="k-select-area">
                          <label>媒体账户:</label>
                          <el-select
                            v-model="advertiser_id"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入媒体账户"
                            :remote-method="remoteMethodGuest"
                            :loading="selectLoading"
                            :size="size"
                            clearable
                            @change="getDouyingInfo"
                          >
                            <el-option-group
                              v-for="group in advertiser_options"
                              :key="group.label"
                              :label="group.label"
                            >
                              <el-option
                                v-for="item in group.options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-option-group>
                          </el-select>
                        </div>
                      </div>
                      <div class="selector" v-if="advertiser_id">
                        <div class="k-select-area">
                          <label>抖音号:</label>
                          <el-select
                            filterable
                            v-model="aweme_id"
                            placeholder="请选择抖音号"
                            :size="size"
                            clearable
                            @change="douyinHaoClick"
                          >
                            <el-option
                              v-for="item in douying_options"
                              :key="item.aweme_id"
                              :label="item.aweme_name +'|('+item.bind_type_text+')'"
                              :value="item.aweme_id"
                            ></el-option>
                          </el-select>
                        </div>
                      </div>
                      <div
                        class="selector"
                        v-if="marketing_goal == 'VIDEO_PROM_GOODS' && advertiser_id"
                      >
                        <div class="k-select-area">
                          <label>商品:</label>
                          <el-select
                            ref="pro"
                            v-model="product_ids"
                            multiple
                            placeholder="请选择商品"
                            :size="size"
                            clearable
                            @focus="openProductDrawer"
                          >
                            <el-option
                              v-for="item in product_options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                          <!-- <div class="k-close-icon" @click="openProductDrawer">
                                                            <i class="el-icon-thumb"></i>
                          </div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table-wrapper">
                    <template>
                      <el-table
                        :data="tableData"
                        border
                        :size="size"
                        style="width: 100%;"
                        class="table-content"
                      >
                        <el-table-column label="计划设置" min-width="220" class-name="table-cell">
                          <template slot="header" slot-scope="scope">计划设置</template>
                          <template slot-scope="scope">
                            <div class="table-view">
                              <div class="add-view">
                                <div class="no-data" v-if="JSON.stringify(adverList) == '{}'">暂无数据</div>
                                <div class="add-line" v-else>
                                  <div class="add-title">
                                    营销目标:
                                    <span>{{adverList.campaign.marketing_goal == 'VIDEO_PROM_GOODS' ? '短视频带货' : '直播带货'}}</span>
                                  </div>
                                  <div class="add-title">
                                    推广方式:
                                    <span>{{adverList.campaign.promotion_way == 'STANDARD' ? '专业版' : '极速版'}}</span>
                                  </div>
                                  <div class="add-title">
                                    投放场景:
                                    <span>{{adverList.campaign.delivery_setting.smart_bid_type == 'SMART_BID_CUSTOM' ? '控成本投放' : '放量投放'}}</span>
                                  </div>
                                  <div class="add-title">
                                    预算类型:
                                    <span>{{adverList.campaign.delivery_setting.budget_mode == 'BUDGET_MODE_DAY' ? '日预算' : '总预算'}}</span>
                                  </div>
                                  <div
                                    class="add-title"
                                    v-if="adverForm.campaign.creative_material_mode == 'CUSTOM_CREATIVE'"
                                  >
                                    呈现方式:
                                    <span>自定义创意</span>
                                  </div>
                                  <div
                                    class="add-title"
                                    v-if="adverForm.campaign.creative_material_mode == 'PROGRAMMATIC_CREATIVE'"
                                  >
                                    呈现方式:
                                    <span>程序化创意</span>
                                  </div>
                                </div>
                              </div>
                              <el-button type="text" @click="openCampaign" :disabled="noClickClass">
                                <el-popover
                                  placement="top-start"
                                  width="200"
                                  trigger="hover"
                                  :content="errorMessage"
                                >
                                  <div slot="reference">添加</div>
                                </el-popover>
                              </el-button>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column label="定向包" min-width="220" class-name="table-cell">
                          <template slot="header" slot-scope="scope">
                            <div class="table-header">
                              <span>定向包</span>
                              <span class="table-header__number">
                                已选定向包:
                                {{targetingList.targetingView.length}}
                              </span>
                              <span class="table-header__clear" @click="clearTargeting">
                                <i class="el-icon-refresh-right"></i>清空
                              </span>
                            </div>
                          </template>
                          <template slot-scope="scope">
                            <div class="table-view">
                              <div class="add-view">
                                <div
                                  class="no-data"
                                  v-if="targetingList.targetingView.length > 0"
                                >已选定向包:</div>
                                <div
                                  class="no-data"
                                  v-if="targetingList.targetingView.length <= 0"
                                >暂无数据</div>
                                <ul class="detail" v-if="targetingList.targetingView.length > 0">
                                  <li
                                    class="data-item"
                                    v-for="item in targetingList.targetingView"
                                    :key="item.id"
                                  >
                                    <div class="ellipsis">
                                      <span slot="reference">{{item.targetingName}}</span>
                                    </div>
                                    <i class="el-icon-close" @click="clearOne(item)"></i>
                                  </li>
                                </ul>
                              </div>
                              <el-button
                                type="text"
                                @click="openTargeting"
                                :disabled="noClickClass"
                              >
                                <el-popover
                                  placement="top-start"
                                  width="200"
                                  trigger="hover"
                                  :content="errorMessage"
                                >
                                  <div slot="reference">添加</div>
                                </el-popover>
                              </el-button>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column label="创意素材" min-width="220" class-name="table-cell">
                          <template slot="header" slot-scope="scope">
                            <div class="table-header">
                              <span>创意素材</span>
                              <span class="table-header__number">已选创意组:{{creativeList.length}}</span>
                              <span class="table-header__clear" @click="clearCreative">
                                <i class="el-icon-refresh-right"></i>清空
                              </span>
                            </div>
                          </template>
                          <template slot-scope="scope">
                            <div class="table-view">
                              <div class="add-view">
                                <div class="no-data" v-if="creativeList.length <= 0">暂无数据</div>
                                <div class="no-data" v-if="creativeList.length > 0">已选创意:</div>
                                <div class="kSourceGroup" v-for="(domins,index) in creativeList">
                                  <div
                                    class="kSourceGroupCon kShadow"
                                    v-for="(imgs,img) in domins.info"
                                    v-if="img <= 2"
                                  >
                                    <div :style="{backgroundImage:'url(' + imgs.top_img + ')'}"></div>
                                  </div>
                                  <div class="kSourceGroupPiont" v-if="domins.info.length > 3">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                  </div>
                                </div>
                              </div>
                              <el-button
                                type="text"
                                @click="openSourceInfo"
                                :disabled="noClickClass"
                              >
                                <el-popover
                                  placement="top-start"
                                  width="200"
                                  trigger="hover"
                                  :content="errorMessage"
                                >
                                  <div slot="reference">添加</div>
                                </el-popover>
                              </el-button>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column
                          v-if="promotion_way == 'STANDARD'"
                          label="创意标签"
                          min-width="220"
                          class-name="table-cell"
                        >
                          <template slot="header" slot-scope="scope">
                            <div class="table-header">
                              <span>创意标签</span>
                              <span class="table-header__number">
                                已选:
                                {{tagList.length}}
                              </span>
                              <span class="table-header__clear" @click="clearTag">
                                <i class="el-icon-refresh-right"></i>清空
                              </span>
                            </div>
                          </template>
                          <template slot-scope="scope">
                            <div class="table-view">
                              <div class="add-view">
                                <div class="no-data" v-if="tagList.length > 0">已选定标签:</div>
                                <div class="no-data" v-if="tagList.length <= 0">暂无数据</div>
                                <ul class="detail" v-if="tagList.length > 0">
                                  <li
                                    class="data-item"
                                    v-for="(item,index) in tagList"
                                    :key="index"
                                  >
                                    <div class="ellipsis">
                                      <span slot="reference">{{item.label}}</span>
                                    </div>
                                    <i class="el-icon-close" @click="clearOneTag(index)"></i>
                                  </li>
                                </ul>
                              </div>
                              <el-button type="text" @click="openTag" :disabled="noClickClass">
                                <el-popover
                                  placement="top-start"
                                  width="200"
                                  trigger="hover"
                                  :content="errorMessage"
                                >
                                  <div slot="reference">添加</div>
                                </el-popover>
                              </el-button>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column label="创意标题" min-width="220" class-name="table-cell">
                          <template slot="header" slot-scope="scope">
                            <div class="table-header">
                              <span>创意标题</span>
                              <span class="table-header__number">
                                已选:
                                {{titleList.length}}
                              </span>
                              <span class="table-header__clear" @click="clearTags">
                                <i class="el-icon-refresh-right"></i>清空
                              </span>
                            </div>
                          </template>
                          <template slot-scope="scope">
                            <div class="table-view">
                              <div class="add-view">
                                <div class="no-data" v-if="titleList.length <= 0">暂无数据</div>
                                <div class="no-data" v-if="titleList.length > 0">已选定标题:</div>

                                <ul class="detail" v-if="titleList.length > 0">
                                  <li class="data-item" v-for="(item,index) in titleList">
                                    <div class="ellipsis">
                                      <span slot="reference">创意标题-{{index+1}}</span>
                                    </div>
                                    <!-- <i class="el-icon-close" @click="clearOneTitle(index)"></i> -->
                                  </li>
                                </ul>
                              </div>
                              <el-button type="text" :disabled="noClickClass" @click="openTitle">
                                <el-popover
                                  placement="top-start"
                                  width="200"
                                  trigger="hover"
                                  :content="errorMessage"
                                >
                                  <div slot="reference">添加</div>
                                </el-popover>
                              </el-button>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                  <div class="footer-line">
                    <el-button
                      type="primary"
                      :size="size"
                      icon="el-icon-document"
                      @click="viewAdver"
                    >预览广告计划</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="content-expand">
              <div class="empty-wrapper" v-if="viewTable.length <= 0">
                <div class="empty-block">
                  <div>
                    <h3 class="empty-title">预览区</h3>
                    <img src="../../assets/images/null_data.png" />
                    <p class="empty-description">请先完成模块配置后，再预览广告计划</p>
                  </div>
                </div>
              </div>
              <div class="expand-config" style="margin-top:16px;" v-show="viewTable.length > 0">
                <div class="expand-title">
                  <span>预览区</span>
                </div>
                <div class="adgroup" style="margin-top:-1px;">
                  <div class="adgroup-header flex">
                    <div class="account">
                      账户：
                      <span class="select-ad-count">已选中：{{multipleSelection.length}}个广告</span>
                    </div>
                    <div>
                      <span class="adgroup-header-info mr16">
                        广告数量：
                        <span class="kNum">{{viewTable.length}}</span>
                      </span>
                      <el-button type="primary" :size="size" @click="actionAdver">提交审核</el-button>
                    </div>
                  </div>
                  <div>
                    <el-table
                      ref="submitData"
                      :data="viewTable"
                      border
                      tooltip-effect="dark"
                      style="width: 100%"
                      @selection-change="handleSelectionChangeView"
                    >
                      <el-table-column type="selection" min-width="100" align="center"></el-table-column>
                      <el-table-column label="广告组名称" min-width="150">
                        <template slot-scope="scope">{{scope.row.adgroup.campaign_name}}</template>
                      </el-table-column>
                      <el-table-column label="广告计划名称" min-width="200">
                        <template slot-scope="scope">{{scope.row.campaign.name}}</template>
                      </el-table-column>
                      <el-table-column label="营销目标" min-width="100">
                        <template slot-scope="scope">
                          <span v-if="scope.row.adgroup.marketing_goal == 'VIDEO_PROM_GOODS'">短视频带货</span>
                          <span v-if="scope.row.adgroup.marketing_goal == 'LIVE_PROM_GOODS'">直播带货</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="预算类型" min-width="100">
                        <template slot-scope="scope">
                          <span v-if="scope.row.adgroup.budget_mode == 'BUDGET_MODE_DAY'">日预算</span>
                          <span v-if="scope.row.adgroup.budget_mode == 'BUDGET_MODE_INFINITE'">预算不限</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="推广方式" min-width="100">
                        <template slot-scope="scope">
                          <span v-if="scope.row.campaign.promotion_way == 'STANDARD'">专业版</span>
                          <span v-if="scope.row.campaign.promotion_way == 'SIMPLE'">极速版</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="投放场景" min-width="150">
                        <template slot-scope="scope">
                          <span
                            v-if="scope.row.campaign.delivery_setting.smart_bid_type == 'SMART_BID_CUSTOM'"
                          >控本投放</span>
                          <span
                            v-if="scope.row.campaign.delivery_setting.smart_bid_type == 'SMART_BID_CONSERVATIVE'"
                          >放量投放</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="创意呈现方式" min-width="150">
                        <template slot-scope="scope">
                          <span
                            v-if="scope.row.campaign.creative_material_mode == 'CUSTOM_CREATIVE'"
                          >自定义创意</span>
                          <span
                            v-if="scope.row.campaign.creative_material_mode == 'PROGRAMMATIC_CREATIVE'"
                          >程序化创意</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="定向包名" min-width="150">
                        <template slot-scope="scope">{{scope.row.campaign.audience.targetingName}}</template>
                      </el-table-column>
                      <el-table-column label="标签" min-width="150">
                        <template slot-scope="scope">
                          <template v-if="promotion_way == 'STANDARD'">
                            <el-tag
                              style="margin-left:10px"
                              :size="size"
                              v-for="item in scope.row.campaign.ad_keywords"
                              :key="item"
                            >{{item}}</el-tag>
                          </template>
                        </template>
                      </el-table-column>
                      <el-table-column label="标题" min-width="150">
                        <template slot-scope="scope">
                          <template v-if="JSON.stringify(scope.row.campaign.creative_list) != '{}'">
                            <span
                              v-for="(item,index) in scope.row.campaign.creative_list"
                              v-if="index == 0"
                            >{{item.title_material.title}}</span>
                          </template>
                          <template
                            v-if="JSON.stringify(scope.row.campaign. programmatic_creative_media_list)!= '{}'"
                          >
                            <span
                              v-for="(item,index) in scope.row.campaign.programmatic_creative_media_list"
                              v-if="index == 0"
                            >
                              <p
                                v-for="(it,i) in item.programmatic_creative_title_list"
                              >{{it.title}}</p>
                            </span>
                          </template>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 创建标题 -->
    <el-drawer
      title="创意标题"
      :visible.sync="titledDawer"
      size="50%"
      :wrapperClosable="wrapper"
      direction="rtl"
      custom-class="k-drawer"
    >
      <div class="drawer-header">
        <div class="header-title">
          <span>创意标题</span>
          <i class="el-icon-close k-drawer-close" @click="titledDawer = false"></i>
        </div>
      </div>
      <el-form :model="titleForm" ref="titleForm">
        <div class="drawer-content">
          <el-form-item label="选择标题包">
            <el-select
              v-model="oldTitleSelect"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="getTitleList"
              :size="size"
            >
              <el-option
                v-for="item in oldTitleSelectOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-button :size="size" type="primary" v-if="oldTitleSelect" @click="autoActionTitle">插入</el-button>
          </el-form-item>
          <el-form-item label="标题包名">
            <el-input
              placeholder="如保存标题包请输入包名"
              minlength="10"
              :size="size"
              v-model="oldTitleName"
              style="width:300px"
            ></el-input>
          </el-form-item>
          <el-divider></el-divider>
          <template v-if="adverForm.campaign.creative_material_mode == 'CUSTOM_CREATIVE'">
            <el-form-item label="批量生成">
              <el-radio-group :size="size" v-model="radioAllAction">
                <el-radio-button label="NO">关闭</el-radio-button>
                <el-radio-button label="YES">开启</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="radioAllAction == 'YES'">
              <el-input
                style="width:70%"
                type="textarea"
                placeholder="请输入批量标题，回车换行"
                v-model="textarea"
                :autosize="{minRows:10,maxRows:50}"
              ></el-input>
              <el-button
                type="text"
                :size="size"
                style="margin-top:10px"
                @click="allTitleAction"
              >批量生成</el-button>
            </el-form-item>
            <el-divider></el-divider>
          </template>
          <el-form-item
            v-for="(domain, index) in titleForm.info"
            :size="size"
            :key="index"
            label="创意标题"
            :prop="'info.' + index + '.title'"
            :rules="{required: true, message: '创意标题不能为空', trigger: 'blur'}"
          >
            <template v-if="adverForm.campaign.creative_material_mode == 'CUSTOM_CREATIVE'">
              <el-input
                placeholder="请输入创意标题"
                minlength="10"
                v-model="domain.title"
                style="width:300px"
                @blur="handleInputBlur"
              >
                <el-button
                  slot="append"
                  icon="el-icon-sort"
                  @click="updateIsShow(index)"
                >{{!domain.isShow ? '展开' : '收起'}}</el-button>
              </el-input>
            </template>
            <template v-if="adverForm.campaign.creative_material_mode == 'PROGRAMMATIC_CREATIVE'">
              <el-input
                @blur="handleInputBlur"
                type="textarea"
                placeholder="请输入批量标题，回车换行"
                v-model="domain.title"
                :autosize="{minRows:3,maxRows:10}"
              ></el-input>
              <el-button
                type="text"
                :size="size"
                style="margin-top:10px"
                @click="updateIsShow(index)"
              >{{!domain.isShow ? '展开' : '收起'}}</el-button>
            </template>
            <div style="margin-top: 10px;" v-if="domain.isShow">
              <span style="margin-left: 10px">词包：</span>
              <template v-for="tag in title_options">
                <el-popover
                  placement="bottom"
                  :title="'类型:'+tag.content_type"
                  width="200"
                  trigger="hover"
                  :content="'替换词:'+tag.words"
                >
                  <el-tag
                    style="margin-left: 10px"
                    slot="reference"
                    :size="size"
                    @click="addTagsWords(index,tag)"
                  >{{tag.name}}</el-tag>
                </el-popover>
              </template>
            </div>
            <el-divider></el-divider>
          </el-form-item>
        </div>
        <div class="drawer-footer">
          <el-button :size="size" type="primary" @click="addTags('')">保存</el-button>
          <el-button :size="size" type="primary" @click="addTags('SAVE')">存入标题库</el-button>
          <el-button :size="size" @click="titledDawer = false">取消</el-button>
        </div>
      </el-form>
    </el-drawer>
    <!-- 创建标签 -->
    <el-drawer
      title="创建标签"
      :visible.sync="drawer"
      :wrapperClosable="wrapper"
      size="70%"
      direction="rtl"
      custom-class="k-drawer"
    >
      <div class="drawer-header">
        <div class="header-title">
          <span>创建标签</span>
          <i class="el-icon-close k-drawer-close" @click="drawer = false"></i>
        </div>
      </div>
      <el-form :model="tagForm" ref="tagForm">
        <div class="drawer-content">
          <el-form-item label="选择标签包" style="margin-bottom:30px">
            <el-select
              ref="tagRef"
              v-model="oldTags"
              multiple
              collapse-tags
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="getTagsInfo"
              :size="size"
            >
              <template v-for="item in oldTagOptions">
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="item.tags.toString()"
                  placement="right"
                >
                  <el-option :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-tooltip>
              </template>
              <!-- <el-option
                          v-for="item in oldTagOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
              </el-option>-->
            </el-select>
            <el-button
              :size="size"
              type="primary"
              v-if="oldTags.length > 0"
              @click="autoActionTag"
            >插入</el-button>
            <el-divider>选择已有标签包</el-divider>
          </el-form-item>

          <el-form-item
            v-for="(domain, index) in tagForm.domains"
            :key="index"
            :label="domain.label"
          >
            <div style="display:flex;justify-content:space-between;">
              <div>
                <el-tag
                  style="margin-left:10px"
                  :key="tag"
                  :size="size"
                  v-for="tag in domain.tags"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(index,tag)"
                >{{tag}}</el-tag>
                <el-input
                  v-focus
                  :size="size"
                  class="input-new-tag"
                  v-if="domain.inputVisible"
                  v-model="domain.inputValue"
                  ref="saveTagInput"
                  style="width:80px"
                  @keyup.enter.native="handleInputConfirm(index)"
                  @blur="handleInputConfirm(index)"
                ></el-input>
                <el-button
                  :size="size"
                  v-if="!domain.inputVisible"
                  class="button-new-tag"
                  @click="showInput(index)"
                >+ 创建</el-button>
                <el-button
                  :size="size"
                  v-if="index == 0"
                  type="primary"
                  icon="el-icon-plus"
                  @click="addTagsData(index)"
                ></el-button>
                <el-button
                  :size="size"
                  v-else
                  type="primary"
                  icon="el-icon-delete"
                  @click="delTagsData(index)"
                ></el-button>
              </div>
              <div>
                <el-input
                  placeholder="标签包名称"
                  v-model="domain.inputTitle"
                  :size="size"
                  class="input-with-select"
                >
                  <el-button slot="append" icon="el-icon-paperclip" @click="saveTagInfo(index)"></el-button>
                </el-input>
              </div>
            </div>
            <el-divider></el-divider>
          </el-form-item>
        </div>
        <div class="drawer-footer">
          <el-button :size="size" type="primary" @click="addTagView">保存</el-button>
          <el-button :size="size" @click="drawer = false">取消</el-button>
        </div>
      </el-form>
    </el-drawer>
    <!-- 添加商品 -->
    <el-drawer
      title="商品列表"
      :visible.sync="productFormVisiable"
      :wrapperClosable="wrapper"
      direction="rtl"
      custom-class="k-drawer"
      size="55%"
      @closeDrawer="closeProduct"
    >
      <div class="drawer-header">
        <div class="header-title">
          <span>选择商品</span>
          <i class="el-icon-close k-drawer-close" @click="productFormVisiable = false"></i>
        </div>
      </div>
      <div class="drawer-content">
        <el-row>
          <el-col :span="6">
            <div class="k-filter-option k-filter-input">
              <el-input v-model="productQuery" placeholder="请输入账户ID或名称" :size="size" clearable>
                <el-button slot="append" icon="el-icon-search" @click="refeshProduct"></el-button>
              </el-input>
            </div>
          </el-col>
          <el-col :span="18" style="text-align:right;">
            <el-button type="primary" :size="size" icon="el-icon-refresh" @click="refeshProduct">刷新</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-top:20px;">
          <el-table
            v-loading="loading"
            :data="productData.data"
            border
            ref="productRef"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            @row-click="clickCheckbox"
          >
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column property="date" label="商品信息" min-width="300">
              <template slot-scope="scope">
                <dl class="k-product-img">
                  <dt>
                    <el-image style="width: 100px; height: 100px" fit="cover" :src="scope.row.img"></el-image>
                  </dt>
                  <dd>
                    <p>{{scope.row.name}}</p>
                    <p>ID:{{scope.row.id}}</p>
                  </dd>
                </dl>
              </template>
            </el-table-column>
            <el-table-column property="category_name" label="分类" width="80"></el-table-column>
            <el-table-column property="market_price" label="售价(元)" width="80"></el-table-column>
            <el-table-column property="inventory" label="库存" width="80"></el-table-column>
            <el-table-column property="product_rate" label="好评率" width="80"></el-table-column>
            <el-table-column property="sale_time" label="上架时间" width="180"></el-table-column>
          </el-table>
          <el-pagination
            background
            ref="pagination"
            style="margin-top:10px;"
            @current-change="handleCurrentChangeSource"
            :current-page="productData.page | number"
            :page-size="productData.page_size | number"
            layout="total, prev, pager, next, jumper"
            :total="productData.total_number | number"
          ></el-pagination>
        </el-row>
      </div>
      <div class="drawer-footer">
        <el-button type="primary" :size="size" @click="saveProduct">保存</el-button>
        <el-button :size="size" @click="canelSelect">取消</el-button>
      </div>
    </el-drawer>

    <!-- 添加定向 -->
    <el-drawer
      title="定向设置"
      :visible.sync="targetingFormVisiable"
      :wrapperClosable="wrapper"
      direction="rtl"
      custom-class="k-drawer"
      size="70%"
    >
      <div class="drawer-header">
        <div class="header-title">
          <span>定向设置</span>
          <i class="el-icon-close k-drawer-close" @click="targetingFormVisiable = false"></i>
        </div>
      </div>
      <div class="drawer-content">
        <div class="k-common-header">
          <el-input
            placeholder="请输入定向名称"
            v-model="targetingList.name"
            clearable
            class="input-with-select"
            style="width:300px"
            :size="size"
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
          <el-button type="primary" :size="size" @click="openTargetingDrawer('add')">新建定向</el-button>
        </div>
        <el-table
          border
          :data="targetingData.data"
          ref="targetingTable"
          @selection-change="handleTargetingChange"
          style="margin-top:20px;"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column property="id" label="ID" min-width="50"></el-table-column>
          <el-table-column property="targetingName" label="定向包名" min-width="100"></el-table-column>
          <el-table-column property="remark" label="备注" width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                :size="size"
                class="c-danger"
                @click="editTargetingData(scope.row,'edit')"
              >编辑</el-button>
              <el-button
                type="text"
                :size="size"
                style="color:red"
                @click="deleteTargeting(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="margin-top:10px;"
          ref="paginationTargrting"
          @current-change="handleCurrentChangeTargeting"
          :current-page="targetingData.current_page | number"
          :page-size="targetingData.per_page | number"
          layout="total, prev, pager, next, jumper"
          :total="targetingData.total | number"
        ></el-pagination>
      </div>
      <div class="drawer-footer">
        <el-button :size="size" type="primary" @click="actionTargetingData">保存</el-button>
        <el-button
          :size="size"
          @click="targetingFormVisiable = false;targetingInfo = [];targetingView = [];"
        >
          取
          消
        </el-button>
      </div>
      <el-drawer
        title="添加定向"
        size="50%"
        :append-to-body="true"
        custom-class="k-drawer"
        :wrapperClosable="wrapper"
        :visible.sync="innerDrawer"
      >
        <el-form :size="size" :model="targetingForm" :rules="rules.tarForm" ref="targetingForm">
          <div class="drawer-header">
            <div class="header-title">
              <span>添加定向</span>
              <i class="el-icon-close k-drawer-close" @click="targetingForm = false"></i>
            </div>
          </div>
          <div class="drawer-content">
            <el-form-item label="定向包名称" prop="targetingName">
              <el-input placeholder="请输入内容" v-model="targetingForm.targetingName" clearable></el-input>
            </el-form-item>
            <el-form-item label="定向模式" v-if="promotion_way != 'STANDARD'">
              <el-radio-group v-model="targetingForm.audience_mode">
                <el-radio-button label="CUSTOM">自定义</el-radio-button>
                <el-radio-button label="AUTO">智能推荐</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <template v-if="targetingForm.audience_mode == 'CUSTOM'">
              <el-form-item label="地域">
                <el-radio-group v-model="targetingForm.district">
                  <el-radio-button label="CITY">省市</el-radio-button>
                  <el-radio-button label="COUNTY">区县</el-radio-button>
                  <el-radio-button label="NONE">不限</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="城市列表"
                v-if="targetingForm.district == 'COUNTY' || targetingForm.district == 'CITY'"
                prop="city"
              >
                <el-cascader v-model="targetingForm.city" :props="tarProp" :options="city_options"></el-cascader>
              </el-form-item>
              <el-form-item
                label="地域状态"
                v-if="targetingForm.district == 'COUNTY' || targetingForm.district == 'CITY'"
                prop="location_type"
              >
                <el-radio-group v-model="targetingForm.location_type">
                  <el-radio label="CURRENT">正在该地区的用户</el-radio>
                  <el-radio label="HOME">居住在该地区的用户</el-radio>
                  <el-radio label="TRAVEL">到该地区旅行的用户</el-radio>
                  <el-radio label="ALL">该地区内的所有用户</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="性别">
                <el-radio-group v-model="targetingForm.gender">
                  <el-radio-button label="GENDER_FEMALE">女性</el-radio-button>
                  <el-radio-button label="GENDER_MALE">男性</el-radio-button>
                  <el-radio-button label="NONE">不限</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="年龄受众">
                <el-checkbox-group v-model="targetingForm.age">
                  <el-checkbox label="AGE_BETWEEN_18_23">18~23</el-checkbox>
                  <el-checkbox label="AGE_BETWEEN_24_30">24~30</el-checkbox>
                  <el-checkbox label="AGE_BETWEEN_31_40">31~40</el-checkbox>
                  <el-checkbox label="AGE_BETWEEN_41_49">41~49</el-checkbox>
                  <el-checkbox label="AGE_ABOVE_50">50以上</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="用户行为" v-if="targetingForm.audience_mode == 'CUSTOM'">
                <el-checkbox-group v-model="targetingForm.aweme_fan_behaviors">
                  <el-checkbox label="FOLLOWED_USER">视频互动-关注</el-checkbox>
                  <el-checkbox label="COMMENTED_USER">视频互动-评论</el-checkbox>
                  <el-checkbox label="LIKED_USER">视频互动-点赞</el-checkbox>
                  <el-checkbox label="SHARED_USER">视频互动-分享</el-checkbox>
                  <el-checkbox label="LIVE_WATCH">直播互动-观看</el-checkbox>
                  <el-checkbox label="LIVE_EFFECTIVE_WATCH">直播互动-有效观看</el-checkbox>
                  <el-checkbox label="LIVE_COMMENT">直播互动-直播评论</el-checkbox>

                  <el-checkbox label="LIVE_EXCEPTIONAL">直播互动-打赏</el-checkbox>
                  <el-checkbox label="LIVE_GOODS_CLICK">直播互动-商品点击</el-checkbox>
                  <el-checkbox label="LIVE_GOODS_ORDER">直播互动-商品下单</el-checkbox>
                  <el-checkbox label="GOODS_CARTS_CLICK">商品互动-购物车点击</el-checkbox>
                  <el-checkbox label="GOODS_CARTS_ORDER">商品互动-购物车下单</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="行为天数" v-if="targetingForm.audience_mode == 'CUSTOM'">
                <el-radio-group v-model="targetingForm.aweme_fan_behaviors_days">
                  <el-radio label="DAYS_15">15天</el-radio>
                  <el-radio label="DAYS_30">30天</el-radio>
                  <el-radio label="DAYS_60">60天</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="达人分类" v-if="targetingForm.aweme_fan_behaviors">
                <div class="block">
                  <el-cascader
                    v-model="targetingForm.aweme_fan_categories"
                    :options="fan_categories_options"
                    :props="{ multiple: true, checkStrictly: true, value:'id', label:'value' }"
                    clearable
                  ></el-cascader>
                </div>
              </el-form-item>
              <el-form-item label="达人列表" v-if="targetingForm.aweme_fan_behaviors">
                <el-select
                  v-model="targetingForm.aweme_fan_accounts"
                  multiple
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in fan_accounts_options"
                    :key="item.aweme_id"
                    :label="item.author_name+'-('+item.category_name+')'"
                    :value="item.aweme_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
            <template v-if="promotion_way == 'STANDARD'">
              <el-form-item label="智能放量">
                <el-radio-group v-model="targetingForm.auto_extend_enabled">
                  <el-radio-button label="0">关闭</el-radio-button>
                  <el-radio-button label="1">开启</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="可放开定向列表" v-if="targetingForm.auto_extend_enabled == 1">
                <el-checkbox-group
                  v-model="targetingForm.auto_extend_targets"
                  prop="auto_extend_targets"
                >
                  <el-checkbox label="AGE">年龄</el-checkbox>
                  <el-checkbox label="REGION">地域</el-checkbox>
                  <el-checkbox label="GENDER">性别</el-checkbox>
                  <el-checkbox label="INTEREST_ACTION">行为兴趣</el-checkbox>
                  <el-checkbox label="CUSTOM_AUDIENCE">更多人群</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="投放平台">
                <el-radio-group v-model="targetingForm.platform">
                  <el-radio label>不限</el-radio>
                  <el-radio label="ANDROID">安卓</el-radio>
                  <el-radio label="IOS">苹果</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="行为定向模式">
                <el-radio-group v-model="targetingForm.smart_interest_action">
                  <el-radio-button label="RECOMMEND">系统推荐</el-radio-button>
                  <el-radio-button label="CUSTOM">自定义</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <template v-if="targetingForm.smart_interest_action == 'CUSTOM'">
                <el-form-item label="行为场景">
                  <el-checkbox-group v-model="targetingForm.action_scene">
                    <el-checkbox label="E-COMMERCE">电商互动行为</el-checkbox>
                    <el-checkbox label="NEWS">咨询互动行为</el-checkbox>
                    <el-checkbox label="APP">APP推广互动行为</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="发生行为天数" v-if="targetingForm.action_scene.length > 0">
                  <el-select
                    v-model="targetingForm.action_days"
                    placeholder="请选择发生行为天数"
                    @change="actionSceneClick"
                  >
                    <el-option
                      v-for="item in day_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="行为类目词" v-if="targetingForm.action_days">
                  <el-cascader
                    v-model="targetingForm.action_categories"
                    placeholder="试试搜索：类型"
                    :options="action_categories_options"
                    :props="{ multiple: true, checkStrictly: true, label:'name',value:'id'}"
                    filterable
                  ></el-cascader>
                </el-form-item>
                <el-form-item
                  label="行为关键词"
                  v-if="targetingForm.action_scene.length > 0 && targetingForm.action_days"
                >
                  <el-select
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="getActionWords"
                    :loading="loading"
                    v-model="targetingForm.action_words"
                    placeholder="请输入行为关键词"
                  >
                    <el-option
                      v-for="item in action_words_options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="兴趣类目词">
                  <el-cascader
                    v-model="targetingForm.interest_categories"
                    placeholder="试试搜索：类型"
                    :options="interest_categories_options"
                    :props="{ multiple: true, checkStrictly: true, label:'name',value:'id'}"
                    filterable
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="兴趣关键词">
                  <el-select
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="getInterestWords"
                    :loading="loading"
                    v-model="targetingForm.interest_words"
                    placeholder="请输入兴趣关键词"
                  >
                    <el-option
                      v-for="item in interest_words_options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <el-form-item label="网络平台">
                <el-checkbox-group v-model="targetingForm.ac">
                  <el-checkbox label="WIFI">WIFI</el-checkbox>
                  <el-checkbox label="2G">2G</el-checkbox>
                  <el-checkbox label="3G">3G</el-checkbox>
                  <el-checkbox label="4G">4G</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="包含人群包">
                <el-select
                  v-model="targetingForm.retargeting_tags_include"
                  multiple
                  filterable
                  placeholder="请选择"
                  @change="updateDesabled($event,'retargeting_other_options')"
                >
                  <el-option
                    v-for="item in retargeting_options"
                    :key="item.value"
                    :label="item.label+'-('+item.status+')'"
                    :disabled="item.disabled"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="排除人群包">
                <el-select
                  v-model="targetingForm.retargeting_tags_exclude"
                  multiple
                  filterable
                  placeholder="请选择"
                  @change="updateDesabled($event,'retargeting_options')"
                >
                  <el-option
                    v-for="item in retargeting_other_options"
                    :key="item.value"
                    :label="item.label+'-('+item.status+')'"
                    :disabled="item.disabled"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="平台精选（排除）" v-if="marketing_goal=='LIVE_PROM_GOODS'">
                <el-checkbox-group v-model="targetingForm.live_platform_tags">
                  <el-checkbox label="LARGE_FANSCOUNT">高关注人群</el-checkbox>
                  <el-checkbox label="ABNORMAL_ACTIVE">高活跃人群</el-checkbox>
                  <el-checkbox label="AWEME_FANS">抖音号粉丝</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </template>
          </div>
          <div class="drawer-footer">
            <el-button
              type="primary"
              :size="size"
              @click="addTargeting"
              v-if="targetingType == 'add'"
            >创建</el-button>
            <el-button
              :size="size"
              type="primary"
              @click="editTargeting"
              v-if="targetingType == 'edit'"
            >修改</el-button>
            <el-button :size="size" @click="innerDrawer = false">取消</el-button>
          </div>
        </el-form>
      </el-drawer>
    </el-drawer>

    <!-- 添加计划 -->
    <el-drawer
      title="计划设置"
      :visible.sync="campaignFormVisiable"
      :wrapperClosable="wrapper"
      direction="rtl"
      custom-class="k-drawer"
      size="60%"
    >
      <div class="drawer-header">
        <div class="header-title">
          <span>计划设置</span>
          <i class="el-icon-close k-drawer-close" @click="campaignFormVisiable = false"></i>
        </div>
      </div>
      <div class="drawer-content" style="background:none;border:none;padding: 0;">
        <el-form
          :size="size"
          :model="adverForm.campaign"
          :rules="rules.campaign"
          ref="campaignForm"
        >
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>投放设置</span>
            </div>
            <el-form-item label="选择已有">
              <el-select
                v-model="oldTemplate"
                filterable
                remote
                reserve-keyword
                :remote-method="remoteMethodTemplate"
                @change="actionTemplate"
                placeholder="请选择模板"
              >
                <el-option
                  v-for="item in templateOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="投放方式">
              <el-radio-group v-model="adverForm.campaign.delivery_setting.smart_bid_type">
                <el-radio-button label="SMART_BID_CUSTOM">控成本投放</el-radio-button>
                <el-radio-button label="SMART_BID_CONSERVATIVE">放量投放</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="投放速度"
              v-if="adverForm.campaign.delivery_setting.smart_bid_type == 'SMART_BID_CUSTOM'"
            >
              <el-radio-group v-model="adverForm.campaign.delivery_setting.flow_control_mode">
                <el-radio-button
                  v-if="promotion_way == 'SIMPLE'"
                  label="FLOW_CONTROL_MODE_FAST"
                >尽快投放</el-radio-button>
                <el-radio-button
                  v-if="promotion_way == 'STANDARD'"
                  label="FLOW_CONTROL_MODE_FAST"
                >尽快投放</el-radio-button>
                <el-radio-button
                  v-if="promotion_way == 'STANDARD'"
                  label="FLOW_CONTROL_MODE_BALANCE"
                >均匀投放</el-radio-button>
                <el-radio-button
                  v-if="promotion_way == 'STANDARD'"
                  label="FLOW_CONTROL_MODE_SMOOTH"
                >优先低成本</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="转化目标">
              <el-radio-group v-model="adverForm.campaign.delivery_setting.external_action">
                <el-radio-button
                  label="AD_CONVERT_TYPE_SHOPPING"
                  v-if="marketing_goal == 'VIDEO_PROM_GOODS'"
                >商品购买</el-radio-button>
                <el-radio-button
                  label="AD_CONVERT_TYPE_QC_FOLLOW_ACTION"
                  v-if="marketing_goal == 'VIDEO_PROM_GOODS'"
                >粉丝提升</el-radio-button>
                <el-radio-button
                  label="AD_CONVERT_TYPE_QC_MUST_BUY"
                  v-if="marketing_goal == 'VIDEO_PROM_GOODS'"
                >点赞评论</el-radio-button>

                <el-radio-button
                  label="AD_CONVERT_TYPE_LIVE_ENTER_ACTION"
                  v-if="marketing_goal == 'LIVE_PROM_GOODS'"
                >进入直播间</el-radio-button>
                <el-radio-button
                  label="AD_CONVERT_TYPE_LIVE_CLICK_PRODUCT_ACTION"
                  v-if="marketing_goal == 'LIVE_PROM_GOODS'"
                >直播间商品点击</el-radio-button>
                <el-radio-button
                  label="AD_CONVERT_TYPE_LIVE_SUCCESSORDER_ACTION"
                  v-if="marketing_goal == 'LIVE_PROM_GOODS'"
                >直播间下单</el-radio-button>
                <el-radio-button
                  label="AD_CONVERT_TYPE_NEW_FOLLOW_ACTION"
                  v-if="marketing_goal == 'LIVE_PROM_GOODS'"
                >直播间粉丝提升</el-radio-button>
                <el-radio-button
                  label="AD_CONVERT_TYPE_LIVE_COMMENT_ACTION"
                  v-if="marketing_goal == 'LIVE_PROM_GOODS'"
                >直播间评论</el-radio-button>
                <el-radio-button
                  label="AD_CONVERT_TYPE_LIVE_SUCCESSORDER_PAY"
                  v-if="marketing_goal == 'LIVE_PROM_GOODS'"
                >直播间成交</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="投放时间" v-if="marketing_goal == 'VIDEO_PROM_GOODS'">
              <el-radio-group
                v-model="adverForm.campaign.delivery_setting.video_schedule_type"
                @change="scheduleTime"
              >
                <el-radio-button label="SCHEDULE_FROM_NOW">从今天起长期投放</el-radio-button>
                <el-radio-button label="SCHEDULE_START_END">设置开始和结束日期</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="投放时间"
              v-if="marketing_goal == 'LIVE_PROM_GOODS' && promotion_way == 'STANDARD'"
            >
              <el-radio-group
                v-model="adverForm.campaign.delivery_setting.live_schedule_type"
                @change="scheduleTime"
              >
                <el-radio-button label="SCHEDULE_FROM_NOW">从今天起长期投放</el-radio-button>
                <el-radio-button label="SCHEDULE_START_END">设置开始和结束日期</el-radio-button>
                <el-radio-button label="SCHEDULE_TIME_FIXEDRANGE">固定时长</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="投放时间"
              v-if="marketing_goal == 'LIVE_PROM_GOODS' && promotion_way == 'SIMPLE'"
            >
              <el-radio-group
                v-model="adverForm.campaign.delivery_setting.live_schedule_type"
                @change="scheduleTime"
              >
                <el-radio-button label="SCHEDULE_TIME_FIXEDRANGE">固定时长</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="选择时段"
              v-if="adverForm.campaign.delivery_setting.live_schedule_type == 'SCHEDULE_START_END' || adverForm.campaign.delivery_setting.video_schedule_type == 'SCHEDULE_START_END'"
              prop="delivery_setting.timeDuan"
            >
              <el-date-picker
                v-model="adverForm.campaign.delivery_setting.timeDuan"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="投放时段">
              <el-radio-group v-model="isScheduleTime" @change="timeClick">
                <el-radio-button label="NONE">不限</el-radio-button>
                <el-radio-button label="ONLY">指定时间段</el-radio-button>
              </el-radio-group>
              <Time
                :visible.sync="scheduleTimeVisible"
                :time.sync="adverForm.campaign.delivery_setting.schedule_time"
              ></Time>
            </el-form-item>
            <el-form-item v-if="adverForm.campaign.delivery_setting.schedule_time" label="所选时段">
              <el-input
                style="width:350px"
                placeholder="请输入内容"
                v-model="adverForm.campaign.delivery_setting.schedule_time"
                :disabled="true"
              >
                <el-button slot="append" icon="el-icon-edit" @click="timeClick">修改</el-button>
              </el-input>
            </el-form-item>
            <el-form-item
              label="固定时段"
              v-if="adverForm.campaign.delivery_setting.live_schedule_type == 'SCHEDULE_TIME_FIXEDRANGE'"
            >
              <el-select
                v-model="adverForm.campaign.delivery_setting.schedule_fixed_range"
                placeholder="请选择固定时长"
              >
                <el-option
                  v-for="item in range_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="预算" prop="delivery_setting.budget">
              <el-input
                placeholder="请输入预算金额"
                v-model="adverForm.campaign.delivery_setting.budget"
                class="input-with-select"
                style="width:300px"
              >
                <el-select
                  v-model="adverForm.campaign.delivery_setting.budget_mode"
                  slot="prepend"
                  placeholder="预算类型"
                  style="width:100px"
                >
                  <template v-if="marketing_goal == 'VIDEO_PROM_GOODS'">
                    <el-option label="日预算" value="BUDGET_MODE_DAY"></el-option>
                    <el-option
                      v-if="promotion_way == 'STANDARD' && adverForm.campaign.delivery_setting.video_schedule_type == 'SCHEDULE_START_END'"
                      label="总预算"
                      value="BUDGET_MODE_TOTAL"
                    ></el-option>
                  </template>
                  <template v-if="marketing_goal == 'LIVE_PROM_GOODS'">
                    <el-option
                      v-if="adverForm.campaign.delivery_setting.live_schedule_type == 'SCHEDULE_TIME_FIXEDRANGE'"
                      label="总预算"
                      value="BUDGET_MODE_TOTAL"
                    ></el-option>
                    <el-option
                      v-if="promotion_way == 'STANDARD' && (adverForm.campaign.delivery_setting.live_schedule_type == 'SCHEDULE_FROM_NOW' || adverForm.campaign.delivery_setting.live_schedule_type == 'SCHEDULE_START_END')"
                      label="日预算"
                      value="BUDGET_MODE_DAY"
                    ></el-option>
                  </template>
                </el-select>
                <template slot="append">元</template>
              </el-input>
              <el-button :size="size" @click="priceTo('300')" style="margin-left:10px">¥ 300</el-button>
              <el-button :size="size" @click="priceTo('500')" style="margin-left:10px">¥ 500</el-button>
              <el-button :size="size" @click="priceTo('1000')" style="margin-left:10px">¥ 1000</el-button>
              <el-button :size="size" @click="priceTo('5000')" style="margin-left:10px">¥ 5000</el-button>
            </el-form-item>
            <el-form-item
              label="出价"
              v-if="adverForm.campaign.delivery_setting.smart_bid_type == 'SMART_BID_CUSTOM'"
              prop="delivery_setting.cpa_bid"
            >
              <el-input
                placeholder="请输入预算金额"
                v-model="adverForm.campaign.delivery_setting.cpa_bid"
                style="width:300px"
              >
                <template slot="append">元/下单</template>
              </el-input>
            </el-form-item>
          </el-card>
          <el-card class="box-card" style="margin-top:10px">
            <div slot="header" class="clearfix">
              <span>创意设置</span>
            </div>
            <el-form-item label="推广卡片" v-if="marketing_goal != 'LIVE_PROM_GOODS'">
              <div class="promotion_card_wrapper">
                <div class="promotion_card">
                  <div class="promotion_card__left">
                    <el-image
                      style="width: 40px; height: 40px; margin-right:10px;"
                      :src="productImg"
                      fit="cover"
                    ></el-image>
                    <div>
                      <div class="promotion_card__left__desc">视频同款商品</div>
                      <div class="promotion_card__left__selling">
                        {{input[0]}}
                        <span
                          v-if="input.length > 1"
                        >&nbsp;&nbsp;&nbsp;+{{input.length-1}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="promotion_card__right">
                    <div>{{adverForm.campaign.creative_list.promotion_card_material.action_button}}</div>
                  </div>
                </div>
                <el-link
                  class="collapse-btn"
                  type="primary"
                  :size="size"
                  style="margin-left:10px"
                  @click="show = !show"
                >{{show ? '收起' : '更改'}}</el-link>
              </div>
              <!-- 折叠内容 -->
              <el-collapse-transition>
                <div
                  v-show="show"
                  style=" width:calc(100% - 68px); padding:20px; box-sizing:border-box; margin-left:68px; border:1px solid #EBEEF5;"
                >
                  <el-form-item label="卡片主图">
                    <el-image style="width: 100px; height: 100px" :src="productImg" fit="cover"></el-image>
                  </el-form-item>
                  <el-form-item label="卡片标题">
                    <el-input
                      style="width:300px"
                      type="text"
                      placeholder="请输入卡片标题"
                      v-model="adverForm.campaign.creative_list.promotion_card_material.title"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="推广卖点">
                    <el-button type="primary" icon="el-icon-plus" @click="addInputInfo">添加卖点</el-button>
                    <p v-for="(item,index) in input" style="margin-top:8px; width:50%;">
                      <el-input v-if="index == 0" v-model="input[index]" placeholder="请输入热点内容"></el-input>
                      <el-input v-else v-model="input[index]" placeholder="请输入热点内容">
                        <el-button
                          slot="append"
                          icon="el-icon-delete"
                          @click="deleteInputInfo(item)"
                        ></el-button>
                      </el-input>
                    </p>
                  </el-form-item>
                  <el-form-item label="智能优选">
                    <el-radio-group
                      v-model="adverForm.campaign.creative_list.promotion_card_material.button_smart_optimization"
                    >
                      <el-radio-button :disabled="buttonDisabled" label="0">关闭智能优选</el-radio-button>
                      <el-radio-button label="1">开启智能优选</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="行动号召按钮">
                    <el-select
                      v-model="adverForm.campaign.creative_list.promotion_card_material.action_button"
                      placeholder="请选择行动按钮"
                    >
                      <el-option
                        v-for="item in action_button_options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-collapse-transition>
            </el-form-item>

            <el-form-item label="抖音主页是否隐藏视频">
              <el-radio-group v-model="adverForm.campaign.is_homepage_hide">
                <el-radio-button label="0">不隐藏</el-radio-button>
                <el-radio-button label="1">隐藏</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="计划名称">
              <el-input
                style="width:400px"
                type="text"
                placeholder="请输入计划名称"
                v-model="adverForm.campaign.name"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="通配符">
              <el-link
                type="primary"
                :size="size"
                icon="el-icon-plus"
                style="margin-left:10px"
                @click="clickText('1')"
              >营销目标</el-link>
              <el-link
                icon="el-icon-plus"
                type="primary"
                style="margin-left:10px"
                @click="clickText('2')"
              >转化目标</el-link>
              <el-link
                icon="el-icon-plus"
                type="primary"
                style="margin-left:10px"
                @click="clickText('3')"
              >定向包名</el-link>

              <el-link
                icon="el-icon-document"
                type="primary"
                style="margin-left:50px"
                @click="insertInfo"
              >插入更多</el-link>
            </el-form-item>
            <el-form-item label="编号起始值">
              <el-input-number v-model="num" :min="1" :max="499" label="编号"></el-input-number>
            </el-form-item>

            <el-form-item label="创意呈现方式" prop="creative_material_mode">
              <el-radio-group
                v-model="adverForm.campaign.creative_material_mode"
                @change="clearTitlesInfo"
              >
                <template v-if="promotion_way == 'STANDARD' && inArray">
                  <el-radio-button label="CUSTOM_CREATIVE">自定义创意</el-radio-button>
                  <el-radio-button label="PROGRAMMATIC_CREATIVE">程序化创意</el-radio-button>
                </template>
                <template v-else-if="promotion_way == 'STANDARD' && !inArray">
                  <el-radio-button label="CUSTOM_CREATIVE">自定义创意</el-radio-button>
                </template>
                <template v-else-if="promotion_way == 'SIMPLE'">
                  <el-radio-button label="CUSTOM_CREATIVE">自定义创意</el-radio-button>
                </template>
                <template v-else>
                  <el-radio-button label="CUSTOM_CREATIVE">自定义创意</el-radio-button>
                  <el-radio-button label="PROGRAMMATIC_CREATIVE">程序化创意</el-radio-button>
                </template>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="行业" v-if="promotion_way == 'STANDARD'" prop="industry_ids">
              <el-cascader v-model="adverForm.campaign.industry_ids" :options="industry_options"></el-cascader>
            </el-form-item>
            <el-form-item
              label="是否生成更多创意"
              v-if="marketing_goal == 'VIDEO_PROM_GOODS'"
              prop="creative_auto_generate"
            >
              <el-radio-group v-model="adverForm.campaign.creative_auto_generate">
                <template
                  v-if="(adverForm.campaign.delivery_setting.external_action == 'AD_CONVERT_TYPE_QC_FOLLOW_ACTION' || adverForm.campaign.delivery_setting.external_action == 'AD_CONVERT_TYPE_QC_MUST_BUY') && promotion_way != 'SIMPLE'"
                >
                  <el-radio-button label="0">关闭</el-radio-button>
                </template>
                <template v-else-if="!inArray">
                  <el-radio-button label="0">关闭</el-radio-button>
                </template>
                <template v-else-if="promotion_way == 'SIMPLE' && inArray">
                  <el-radio-button label="1">开启</el-radio-button>
                </template>
                <template v-else>
                  <el-radio-button label="0">关闭</el-radio-button>
                  <el-radio-button label="1">开启</el-radio-button>
                </template>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否保存为模板">
              <el-radio-group v-model="isTemplate">
                <el-radio-button label="YES">是</el-radio-button>
                <el-radio-button label="NO">否</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="模板名称" v-if="isTemplate == 'YES'">
              <el-input v-model="templateName" label="请输入模板名称"></el-input>
            </el-form-item>
            <el-form-item label="模板备注" v-if="isTemplate == 'YES'">
              <el-input type="textarea" :rows="4" placeholder="请输入备注内容" v-model="templateRemark"></el-input>
            </el-form-item>
          </el-card>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button :size="size" type="primary" @click="actionCampaignData">保存</el-button>
        <el-button
          :size="size"
          v-if="isTemplate == 'YES'"
          type="primary"
          @click="saveTemplate"
        >保存为模板</el-button>
        <el-button :size="size" @click="campaignFormVisiable = false;">取 消</el-button>
      </div>
    </el-drawer>

    <!-- 通配符 -->
    <el-dialog width="30%" title="通配符" :visible.sync="dialogTableVisible">
      <el-table border :data="gridData" ref="tonpeiTable" @selection-change="handleTongpeiChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column property="name" label="通配符" width="100"></el-table-column>
        <el-table-column property="remark" label="备注" width="380"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button :size="size" @click="dialogTableVisible = false">取 消</el-button>
        <el-button :size="size" type="primary" @click="tongpeiSelect">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 素材选择 -->
    <el-dialog title="选择素材" :visible.sync="SourceDialog" width="98%" custom-class="SourceDialogV2">
      <div class="kSourceBox">
        <div class="kSourceItem">
          <div class="kSourceItemTop">
            <p>
              <b>创意组</b>&nbsp;&nbsp;&nbsp;&nbsp;
              <span>创意组数量：{{sourceItem.length}}组</span>
              <el-button
                type="text"
                :size="size"
                class="kSourceItemTop-add"
                @click="addSourceGroup"
                v-if="sourceItem.length > 0"
              >添加素材组</el-button>
            </p>
            <p>
              <b>
                要求：{{adverForm.campaign.creative_material_mode == 'CUSTOM_CREATIVE' ? '自定义' : '程序化'}}创意：每组素材最少{{sourceMin}}个;最多{{sourceMax}}个;
                <span
                  style="color: red;"
                >{{message}}</span>
              </b>
            </p>
          </div>
          <div class="kSourceItemCon" id="dataDiv">
            <template v-if="sourceItem.length <= 0">
              <div class="kItems">
                <div class="kItemsTitle">创意组</div>
                <div class="kItemsCon">
                  <div class="kItemsNull">
                    <img src="../../assets/images/null_data2.png" />
                    <p>尚未添加素材</p>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                class="kItems"
                v-for="(domain, index) in sourceItem"
                :key="index"
                :ref="'m_'+index"
                :class="index == selectIndex ? 'hov' : ''"
                @click="changeSelectIndex(index)"
              >
                <div class="kItemsTitle">
                  创意组-{{index+1}}
                  <span style="margin-left:20px">已选:{{domain.info.length}}</span>
                  <i class="el-icon-circle-close" @click="clearAdcreativeGroup(index)"></i>
                </div>
                <div class="kItemsCon">
                  <template v-for="(item,i) in domain.info">
                    <template v-if="item.sourceType == 'IMAGE'">
                      <div class="kItemsConVideo" style="width:130px;">
                        <i @click="clearAdcreativeOne(index,i)"></i>
                        <div class="kItemsConVideoC">
                          <a>
                            <img :src="item.file" />
                          </a>
                        </div>
                      </div>
                    </template>
                    <template v-if="item.sourceType == 'VIDEO'">
                      <div class="kItemsConVideo">
                        <i @click="clearAdcreativeOne(index,i)"></i>
                        <div class="kItemsConVideoC" v-if="item.top_img">
                          <a>
                            <video
                              height="85"
                              :src="item.file"
                              controls="controls"
                              type="video/mp4"
                            ></video>
                          </a>
                        </div>
                        <div class="kItemsConVideoC" v-if="item.top_img">
                          <a>
                            <img :src="item.top_img" />
                          </a>
                        </div>
                        <div class="kNullCover" v-if="!item.top_img">
                          <img src="../../assets/images/nullcover.jpg" style="width: 28.5%;" />
                          <p>暂无封面</p>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="kSourceIcon"></div>
        <div class="kSourceDepot">
          <h4>
            <span>素材库</span>
            <p>已选素材：选择素材后自动识别素材类型（竖版、横版、图片、视频）</p>
          </h4>
          <div class="kDepotSearch">
            <el-form
              ref="searchForm"
              :inline="true"
              label-suffix=":"
              :model="searchForm"
              :size="size"
            >
              <el-form-item label="素材名称">
                <el-input v-model="searchForm.name" placeholder="输入素材名称（支持模糊搜索）"></el-input>
              </el-form-item>
              <el-form-item label="图片来源">
                <el-radio-group v-model="searchForm.sourceType">
                  <el-radio-button label="video">视频</el-radio-button>
                  <el-radio-button label="image">图片</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="视频来源">
                <el-select v-model="searchForm.type" placeholder="请选择视频来源">
                  <el-option
                    v-for="item in source_options"
                    :disabled="item.disabled == adverForm.campaign.creative_material_mode"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getSourceList('1')">查询</el-button>
                <el-button type="primary" @click="clearSearch">清空选择</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="kDepotCon" v-loading="loading">
            <div class="material">
              <template v-for="(item,index) in sourceData.data">
                <template v-if="item.type == 'image'">
                  <el-tooltip class="item" effect="dark" content="类型：图片" placement="top">
                    <div
                      class="material-item"
                      :style="item.size/1024 > 1536 ? 'border:1px solid red' : ''"
                      @click="changeCard(item)"
                    >
                      <div class="material-img" :style="{backgroundImage:'url('+item.file+')'}">
                        <div class="material-other">
                          <div class="flex">
                            <div
                              class="material-other-item material-size"
                            >{{item.width}}x{{item.height}}</div>
                          </div>
                        </div>
                      </div>
                      <div class="material-info">
                        <div class="material-name">{{item.name}}</div>
                      </div>
                    </div>
                  </el-tooltip>
                </template>
                <template v-if="item.type == 'video'">
                  <el-tooltip class="item" effect="dark" content="类型：视频" placement="top">
                    <div
                      class="material-item"
                      :style="item.size/1024 > 102400 ? 'border:1px solid red' : ''"
                      @click="changeCard(item)"
                    >
                      <div>
                        <div
                          class="material-img"
                          :style="{backgroundImage:'url('+item.top_img+')'}"
                        >
                          <div class="material-other">
                            <div class="flex">
                              <div
                                class="material-other-item material-size"
                              >{{item.width}}x{{item.height}}</div>
                            </div>
                          </div>
                        </div>
                        <div class="material-info">
                          <div class="material-name">{{item.name}}</div>
                        </div>
                      </div>
                      <div style="text-align: center;">
                        <el-button size="mini" @click="viewVideo(item)">预览</el-button>
                      </div>
                    </div>
                  </el-tooltip>
                </template>
              </template>
            </div>
            <div class="el-pagination">
              <el-pagination
                background
                ref="pagination"
                @current-change="handleCurrentChange"
                :current-page="sourceData.current_page | number"
                :page-size="sourceData.per_page | number"
                layout="total, prev, pager, next, jumper"
                :total="sourceData.total | number"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="SourceDialog = false" :size="size">取 消</el-button>
        <el-button type="primary" :size="size" @click="saveAdcreative">保 存</el-button>
      </div>
    </el-dialog>

    <!--视频预览-->
    <el-dialog
      title="视频预览"
      :visible.sync="SourceDialogVideo"
      custom-class="SourceDialogVideo"
      :before-close="handleCloseVideo"
    >
      <div class="kVideoDetail">
        <div class="kVideoDetailT">
          <h5>视频：</h5>
          <div>
            <video
              height="185"
              controls="controls"
              :src="sourceView.SourceDialogVideoUrl"
              type="video/mp4"
            >您的浏览器不支持视频标记</video>
          </div>
        </div>
        <div class="kVideoDetailB">
          <h5>封面：</h5>
          <div>
            <img :src="sourceView.SourceDialogVideoCover" />
          </div>
          <p>
            宽x高：{{sourceView.SourceDialogVideoSize}}
            <br />
            上传时间：{{sourceView.SourceDialogVideoTime}}
            <br />
            唯一标识：{{sourceView.SourceDialogVideoId}}
            <br />
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 引入公共组件供页面使用
import Time from '@/components/Time.vue'

export default {
  props: ['info', 'media', 'dialogMediaVisible'],
  components: {
    Time
  },
  data() {
    return {
      wrapper: false,
      searchForm: {
        name: '',
        type: 'LOCAL',
        sourceType: 'video'
      },
      templateName: '',
      templateRemark: '',
      oldTemplate: '',
      isTemplate: 'NO',
      radioAllAction: 'NO',
      textarea: '',
      project: '',
      viewTable: [],
      input: ['商家倾情推荐'],
      size: 'mini',
      loading: false,
      SourceDialogVideo: false,
      activeName: 'first',
      containerShow: false,
      selectLoading: false,
      productFormVisiable: false,
      campaignFormVisiable: false,
      scheduleTimeVisible: false,
      dialogTableVisible: false,
      targetingFormVisiable: false,
      innerDrawer: false,
      drawer: false,
      titledDawer: false,
      SourceDialog: false,
      isScheduleTime: 'NONE',
      errorMessage: '请选择账户',
      noClickClass: true,
      productQuery: '',
      num: '1',
      show: false,
      oldTags: [], //已选标签
      tarProp: {
        multiple: true,
        checkStrictly: true
      },
      sourceData: {
        total: 0,
        current_page: 1,
        per_page: 20,
        data: []
      },
      sourceView: {
        SourceDialogVideoUrl: '',
        SourceDialogVideoCover: '',
        SourceDialogVideoSize: '',
        SourceDialogVideoTime: '',
        SourceDialogVideoId: ''
      },

      source_options: [
        {
          value: 'LOCAL',
          label: '本地素材',
          disabled: ''
        },
        {
          value: 'AWEME',
          label: '抖音号下',
          disabled: 'PROGRAMMATIC_CREATIVE'
        }
      ],
      gridData: [
        {
          id: '1',
          name: '营销目标',
          value: '{营销目标}',
          remark: '短视频带货/直播带货'
        },
        {
          id: '2',
          name: '转化目标',
          value: '{转化目标}',
          remark: '计划设置的转化目标名称'
        },
        {
          id: '3',
          name: '定向包名',
          value: '{定向包名}',
          remark: '计划使用的定向包名称'
        },
        {
          id: '4',
          name: '素材名',
          value: '{素材名}',
          remark: '计划下第一个素材的名称'
        },
        {
          id: '6',
          name: '日期',
          value: '{日期}',
          remark: '预览广告的日期，格式：04-18'
        },
        {
          id: '7',
          name: '时间',
          value: '{时间}',
          remark: '预览广告的时间，格式：16:35:44'
        },
        {
          id: '8',
          name: '编号',
          value: '{编号}',
          remark:
            '系统自动为计划生成编号，以避免计划名称重复，您可以自定义编号起始值'
        }
      ],
      rowSelectFlag: false,
      hasSelectList: ['6', '7', '8'],
      marketing_goal_options: [
        {
          value: 'VIDEO_PROM_GOODS',
          label: '短视频带货'
        },
        {
          value: 'LIVE_PROM_GOODS',
          label: '直播带货'
        }
      ],
      action_categories_options: [],
      oldTitleSelect: '',
      oldTitleName: '',
      oldTitleSelectOptions: [],
      oldTagOptions: [],
      templateOptions: [],
      range_options: [
        {
          value: '3600',
          label: '1小时'
        },
        {
          value: '7200',
          label: '2小时'
        },
        {
          value: '10800',
          label: '3小时'
        },
        {
          value: '14400',
          label: '4小时'
        },
        {
          value: '18000',
          label: '5小时'
        },
        {
          value: '21600',
          label: '6小时'
        },
        {
          value: '25200',
          label: '7小时'
        },
        {
          value: '28800',
          label: '8小时'
        },
        {
          value: '32400',
          label: '9小时'
        },
        {
          value: '36000',
          label: '10小时'
        },
        {
          value: '39600',
          label: '11小时'
        },
        {
          value: '43200',
          label: '12小时'
        },
        {
          value: '46800',
          label: '13小时'
        },
        {
          value: '50400',
          label: '14小时'
        },
        {
          value: '54000',
          label: '15小时'
        },
        {
          value: '57600',
          label: '16小时'
        },
        {
          value: '61200',
          label: '17小时'
        },
        {
          value: '64800',
          label: '18小时'
        },
        {
          value: '68400',
          label: '19小时'
        },
        {
          value: '72000',
          label: '20小时'
        },
        {
          value: '75600',
          label: '21小时'
        },
        {
          value: '79200',
          label: '22小时'
        },
        {
          value: '82800',
          label: '23小时'
        },
        {
          value: '86400',
          label: '24小时'
        }
      ],
      action_words_options: [],
      interest_categories_options: [],
      interest_words_options: [],
      day_options: [
        {
          value: '7',
          label: '7天'
        },
        {
          value: '15',
          label: '15天'
        },
        {
          value: '30',
          label: '30天'
        },
        {
          value: '60',
          label: '60天'
        },
        {
          value: '90',
          label: '90天'
        },
        {
          value: '180',
          label: '180天'
        },
        {
          value: '365',
          label: '365天'
        }
      ],
      promotion_way_options: [
        {
          value: 'STANDARD',
          label: '专业版'
        },
        {
          value: 'SIMPLE',
          label: '极速版'
        }
      ],
      industry_options: [],
      city_options: [],
      retargeting_options: [],
      retargeting_other_options: [],
      action_button_options: [
        {
          value: '查看详情',
          label: '查看详情'
        },
        {
          value: '更多精彩',
          label: '更多精彩'
        },
        {
          value: '立即抢购',
          label: '立即抢购'
        },
        {
          value: '了解更多',
          label: '了解更多'
        },
        {
          value: '领取福利',
          label: '领取福利'
        },
        {
          value: '专属优惠',
          label: '专属优惠'
        },
        {
          value: '去逛逛',
          label: '去逛逛'
        },
        {
          value: '更多秒杀',
          label: '更多秒杀'
        }
      ],
      title_options: [],
      fan_categories_options: [],
      fan_accounts_options: [],
      advertiser_options: [],
      douying_options: [],
      product_ids_new: [],
      product_options_new: [],
      value: '',
      advertiser_id: '', //正式删除
      marketing_goal: '',
      promotion_way: '',
      product_ids: [], //正式删除3519787716051092000
      product_options: [],
      aweme_id: '', //正式删除4318528239054927
      productData: {
        total_number: 0,
        page_size: 15,
        page: 1,
        last_page: 0,
        data: []
      },
      tableData: [{}],
      rules: {
        campaign: {
          'delivery_setting.budget': [
            {
              required: true,
              message: '请填写预算金额',
              trigger: ['change', 'blur']
            },
            {
              validator: function(rule, value, callback) {
                if (!this.adverForm.campaign.delivery_setting.budget_mode) {
                  callback(new Error('预算类型不能为空请选择'))
                }
                var reg = new RegExp(/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/)
                if (
                  this.adverForm.campaign.delivery_setting.budget_mode ==
                    'BUDGET_MODE_DAY' &&
                  (value < 300 || value > 9999999.99)
                ) {
                  callback(new Error('预算不能小于300元,大于9999999.99元'))
                }
                if (!reg.test(value)) {
                  callback(new Error('请输入正确金额'))
                }
                callback()
              }.bind(this),
              trigger: ['change', 'blur']
            }
          ],
          'delivery_setting.cpa_bid': [
            {
              required: true,
              message: '请填写出价',
              trigger: ['change', 'blur']
            },
            {
              validator: function(rule, value, callback) {
                var reg = new RegExp(/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/)

                if (
                  value - 0 >
                  this.adverForm.campaign.delivery_setting.budget - 0
                ) {
                  callback(new Error('出价不能大于预算金额'))
                }
                if (!reg.test(value)) {
                  callback(new Error('请输入正确金额'))
                }
                callback()
              }.bind(this),
              trigger: ['change', 'blur']
            }
          ],
          'delivery_setting.timeDuan': [
            {
              required: function(rule, value, callback) {
                if (
                  this.adverForm.campaign.delivery_setting.timeDuan.length <=
                    0 &&
                  (this.adverForm.campaign.delivery_setting
                    .live_schedule_type == 'SCHEDULE_START_END' ||
                    this.adverForm.campaign.delivery_setting
                      .video_schedule_type == 'SCHEDULE_START_END')
                ) {
                  return true
                } else {
                  return false
                }
              }.bind(this),
              message: '请选择开始结束时间',
              trigger: ['change', 'blur']
            }
          ],
          industry_ids: [
            {
              required: function() {
                if (
                  this.promotion_way == 'STANDARD' &&
                  this.adverForm.campaign.industry_ids.length <= 0
                ) {
                  return true
                }
                return false
              },
              message: '请选择行业',
              trigger: 'change'
            }
          ],
          creative_material_mode: [
            {
              required: true,
              message: '请选择创意呈现方式',
              trigger: 'change'
            }
          ],
          creative_auto_generate: [
            {
              required: true,
              message: '请选择是否开启生成更多创意',
              trigger: 'change'
            }
          ]
        },
        tarForm: {
          targetingName: [
            {
              required: true,
              message: '请填写定向包名称',
              trigger: 'change'
            }
          ],
          city: [
            {
              required: function(rule, value, callback) {
                if (
                  (this.targetingForm.district == 'COUNTY' ||
                    this.targetingForm.district == 'CITY') &&
                  this.targetingForm.city.length <= 0
                ) {
                  return true
                }
                return false
              }.bind(this),
              message: '请选择具体定向城市',
              trigger: 'change'
            },
            {
              validator: function(rule, value, callback) {
                var error = []
                var errorss = []
                if (this.targetingForm.district == 'COUNTY') {
                  value.forEach(function(item, index) {
                    if (item.length != 3) {
                      error.push(1)
                    }
                  })
                }
                if (this.targetingForm.district == 'CITY') {
                  value.forEach(function(item, index) {
                    if (item.length > 2) {
                      errorss.push(1)
                    }
                  })
                }

                if (error.length > 0) {
                  callback(new Error('【区县】类型只能选择三级目录'))
                }
                if (errorss.length > 0) {
                  callback(new Error('【省市】类型只能选择一或二级目录'))
                }

                callback()
              }.bind(this),
              trigger: 'change'
            }
          ],
          location_type: [
            {
              required: function(rule, value, callback) {
                if (
                  (this.targetingForm.district == 'COUNTY' ||
                    this.targetingForm.district == 'CITY') &&
                  !this.targetingForm.location_type
                ) {
                  return true
                }
                return false
              }.bind(this),
              message: '请选择地域定向用户类型',
              trigger: 'change'
            }
          ],
          auto_extend_targets: [
            {
              required: function(rule, value, callback) {
                if (
                  this.targetingForm.auto_extend_enabled == '1' &&
                  !this.targetingForm.auto_extend_targets.length <= 0
                ) {
                  return true
                }
                return false
              }.bind(this),
              message: '请选择可开放定向列表',
              trigger: 'change'
            }
          ]
        }
      },
      titleForm: {
        info: []
      },
      tagForm: {
        domains: [
          {
            label: '创意标签组-1',
            inputVisible: false,
            inputValue: '',
            inputTitle: '',
            inputId: '',
            tags: []
          }
        ]
      },
      targetingList: {
        name: '',
        targetingInfo: [],
        targetingView: [] //定向存放
      },
      adverList: {}, //创意组存放
      titleList: [], //标题存放
      tagList: [], //标签存放
      creativeList: [], //创意存放

      sourceItem: [],
      targetingId: '',
      targetingType: 'add',
      targetingForm: {
        targetingName: '',
        audience_mode: 'CUSTOM',
        district: 'NONE',
        city: [],
        location_type: 'ALL',
        gender: 'NONE',
        age: ['AGE_BETWEEN_18_23'],
        aweme_fan_behaviors: [],
        aweme_fan_behaviors_days: '',
        aweme_fan_categories: [],
        aweme_fan_accounts: [],
        auto_extend_enabled: '0',
        auto_extend_targets: [],
        platform: '',
        smart_interest_action: '',
        action_scene: [],
        action_days: '',
        action_categories: [],
        action_words: [],
        interest_categories: [],
        interest_words: [],
        ac: [],
        retargeting_tags_include: [],
        retargeting_tags_exclude: [],
        live_platform_tags: []
      },
      targetingData: {
        total: 0,
        per_page: 10,
        current_page: 1,
        last_page: 0,
        data: [
          {
            name: '测试定向1',
            id: '1',
            item: 'dsadsdsadsadsad'
          },
          {
            name: '测试定向2',
            id: '2',
            item: 'dsadsdsadsadsad'
          },
          {
            name: '测试定向3',
            id: '3',
            item: 'dsadsdsadsadsad'
          }
        ]
      },
      productImg: '',
      adverForm: {
        adgroup: {
          advertiser_id: '',
          campaign_name: '',
          marketing_goal: 'VIDEO_PROM_GOODS',
          budget_mode: 'BUDGET_MODE_INFINITE'
        },
        campaign: {
          advertiser_id: '',
          name: '{日期}-{时间}-{编号}',
          marketing_goal: 'VIDEO_PROM_GOODS',
          promotion_way: 'STANDARD',
          aweme_id: '',
          product_ids: [],
          delivery_setting: {
            smart_bid_type: 'SMART_BID_CUSTOM',
            flow_control_mode: 'FLOW_CONTROL_MODE_FAST',
            budget_mode: '',
            external_action: 'AD_CONVERT_TYPE_SHOPPING',
            video_schedule_type: 'SCHEDULE_FROM_NOW',
            live_schedule_type: 'SCHEDULE_FROM_NOW',
            schedule_time: '',
            budget: '300',
            cpa_bid: '',
            timeDuan: [], //临时
            start_time: '',
            end_time: '',
            schedule_fixed_range: '3600'
          },
          audience: {},
          creative_material_mode: '',
          industry_ids: [], //临时
          first_industry_id: '',
          second_industry_id: '',
          third_industry_id: '',
          ad_keywords: [],
          creative_list: {
            promotion_card_material: {
              title: '视频同款商品',
              image_id: '',
              action_button: '查看详情',
              button_smart_optimization: '0',
              selling_points: ['商家倾情推荐']
            }
          },
          creative_auto_generate: '0',
          is_homepage_hide: '1'
        }
      },
      buttonDisabled: false,
      selectionStart: '',
      bind_type: '',
      sourceMax: 0,
      sourceMin: 0,
      message: '',
      selectIndex: 0,
      multipleSelection: []
    }
  },
  watch: {
    advertiser_id: function(newValue, oldValue) {
      this.adverForm.adgroup.advertiser_id = newValue
      this.adverForm.campaign.advertiser_id = newValue
    },
    hasSelectList: function(newValue, oldValue) {
      var arr = []
      this.gridData.forEach(
        function(item, index) {
          if (this.hasSelectList.indexOf(item.id) != -1) {
            arr.push(item.value)
          }
        }.bind(this)
      )
      this.adverForm.campaign.name = arr.join('-')
    },
    input: function(newValue, oldValue) {
      this.adverForm.campaign.creative_list.promotion_card_material.selling_points = newValue
    },
    product_ids: function(newValue, oldValue) {
      this.adverForm.campaign.product_ids = newValue
    },
    promotion_way: function(newValue, oldValue) {
      this.adverForm.campaign.promotion_way = newValue
    },
    aweme_id: function(newValue, oldValue) {
      this.adverForm.campaign.aweme_id = newValue
    },
    marketing_goal: function(newValue, oldValue) {
      if (newValue == 'VIDEO_PROM_GOODS') {
        this.adverForm.campaign.delivery_setting.external_action =
          'AD_CONVERT_TYPE_SHOPPING'
      }
      if (newValue == 'LIVE_PROM_GOODS') {
        this.adverForm.campaign.delivery_setting.external_action =
          'AD_CONVERT_TYPE_LIVE_ENTER_ACTION'
      }

      this.adverForm.adgroup.marketing_goal = newValue
      this.adverForm.campaign.marketing_goal = newValue
    },
    //监听智能优选
    isButton: function(newValue, oldValue) {
      if (
        newValue.promotion_way == 'SIMPLE' &&
        newValue.marketing_goal == 'VIDEO_PROM_GOODS' &&
        newValue.creative_material_mode == 'CUSTOM_CREATIVE'
      ) {
        this.buttonDisabled = true
        this.adverForm.campaign.creative_list.promotion_card_material.button_smart_optimization =
          '1'
      } else {
        this.buttonDisabled = false
        this.adverForm.campaign.creative_list.promotion_card_material.button_smart_optimization =
          '0'
      }
    },
    liveObj: function(newValue, oldValue) {
      if (
        newValue.marketing_goal == 'LIVE_PROM_GOODS' &&
        newValue.promotion_way == 'STANDARD'
      ) {
        this.adverForm.campaign.delivery_setting.live_schedule_type =
          'SCHEDULE_FROM_NOW'
      }
      if (
        newValue.marketing_goal == 'LIVE_PROM_GOODS' &&
        newValue.promotion_way == 'SIMPLE'
      ) {
        this.adverForm.campaign.delivery_setting.live_schedule_type =
          'SCHEDULE_TIME_FIXEDRANGE'
        this.adverForm.campaign.delivery_setting.budget_mode =
          'BUDGET_MODE_TOTAL'
      }
    },
    //监听错误信息生成
    objError: function(newValue, oldValue) {
      if (!newValue.advertiser_id) {
        this.errorMessage = '请选择账户'
        this.noClickClass = true
      } else if (!newValue.aweme_id) {
        this.errorMessage = '请选择抖音号'
        this.noClickClass = true
      } else if (
        newValue.marketing_goal == 'VIDEO_PROM_GOODS' &&
        newValue.product_ids.length <= 0
      ) {
        this.errorMessage = '请选择商品信息'
        this.noClickClass = true
      } else {
        this.errorMessage = '请添加'
        this.noClickClass = false
      }
    }
  },
  computed: {
    isButton: function() {
      return {
        marketing_goal: this.marketing_goal,
        creative_material_mode: this.adverForm.campaign.creative_material_mode,
        promotion_way: this.promotion_way
      }
    },
    liveObj: function() {
      return {
        marketing_goal: this.marketing_goal,
        promotion_way: this.promotion_way
      }
    },
    objError: function() {
      return {
        advertiser_id: this.advertiser_id,
        marketing_goal: this.marketing_goal,
        aweme_id: this.aweme_id,
        product_ids: this.product_ids
      }
    },
    totalNum: function() {
      if (this.promotion_way == 'STANDARD') {
        return (
          this.targetingList.targetingView.length *
          this.tagList.length *
          this.creativeList.length
        )
      } else {
        return (
          this.targetingList.targetingView.length * this.creativeList.length
        )
      }
    }
  },
  directives: {
    //注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function(el) {
        // 聚焦元素
        el.querySelector('input').focus()
      }
    }
  },
  methods: {
    changeMedia: function() {
      this.$emit('update:media', '')
      this.$emit('update:dialogMediaVisible', true)
    },
    //选择已选模板回填页面
    actionTemplate: function(value) {
      this.templateOptions.forEach(
        function(item, index) {
          if (item.id == value) {
            this.adverForm.campaign = item.data.campaign
            this.isScheduleTime = item.data.isScheduleTime
          }
        }.bind(this)
      )
    },
    //获取模板列表
    remoteMethodTemplate: function(query) {
      var params = {
        advertiser_id: this.advertiser_id,
        marketing_goal: this.marketing_goal,
        promotion_way: this.promotion_way,
        aweme_id: this.aweme_id,
        product_ids: this.product_ids[0],
        query: query
      }
      this.$api.adPromotion.remoteMethodTemplate(params).then(res => {
        this.templateOptions = res.data
      })
    },
    //保存为模板
    saveTemplate: function() {
      this.$refs['campaignForm'].validate(
        function(valid) {
          if (valid) {
            if (!this.templateName) {
              this.$message({
                showClose: true,
                message: '如果要保存为模板,模板名称是必填的',
                type: 'error'
              })
              return
            }

            var data = {
              isScheduleTime: this.isScheduleTime,
              campaign: this.adverForm.campaign
            }
            var params = {
              name: this.templateName,
              remark: this.templateRemark,
              advertiser_id: this.advertiser_id,
              data: data,
              marketing_goal: this.marketing_goal,
              promotion_way: this.promotion_way,
              aweme_id: this.aweme_id,
              product_ids: this.product_ids[0],
              isSave: ''
            }
            this.$api.adPromotion.saveTemplate(params).then(res => {
              if (res.code == 7777) {
                params.isSave = 1
                this.$api.adPromotion.saveTemplate(params).then(res1 => {
                  if (res1.code == 0) {
                    this.$message({
                      showClose: true,
                      message: '模板保存成功了！',
                      type: 'success'
                    })
                    this.remoteMethodTemplate('')
                  } else {
                    params.isSave = ''
                    this.$message({
                      showClose: true,
                      message: res1.message,
                      type: 'error'
                    })
                  }
                })
                return
              } else if (res.code == 9999) {
                this.$confirm('模板名称已存在，是否覆盖?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                })
                  .then(() => {
                    params.isSave = 1
                    this.$api.adPromotion.saveTemplate(params).then(res2 => {
                      if (res2.code == 0) {
                        this.$message({
                          showClose: true,
                          message: '模板保存成功了！',
                          type: 'success'
                        })
                        this.remoteMethodTemplate('')
                      } else {
                        params.isSave = ''
                        this.$message({
                          showClose: true,
                          message: res2.message,
                          type: 'error'
                        })
                      }
                    })
                  })
                  .catch(() => {
                    this.$message({
                      type: 'info',
                      message: '已取消保存模板'
                    })
                    return
                  })
              }
            })
          }
        }.bind(this)
      )
    },
    //保存标签包
    saveTagInfo: function(index) {
      this.$refs['tagRef'].blur()
      if (
        !this.tagForm.domains[index].inputTitle ||
        this.tagForm.domains[index].tags.length <= 0
      ) {
        this.$message({
          showClose: true,
          message:
            '如果要保存标签包,当前标签包包名必填,标签内容不能为空且至少一个标签',
          type: 'error'
        })
        return
      }

      var postData = {
        name: this.tagForm.domains[index].inputTitle,
        tags: this.tagForm.domains[index].tags,
        advertiser_id: this.advertiser_id,
        remark: '',
        isSave: ''
      }

      //首次查询标签包名称是否存在
      this.$api.adPromotion.saveTagInfo(postData).then(res => {
        if (res.code == 9999) {
          this.$confirm('该标签包名已存在, 是否覆盖?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.$prompt('请输入备注内容', '提示', {
                confirmButtonText: '保存',
                cancelButtonText: '取消',
                inputValidator: function(value) {
                  if (value.length > 20) {
                    return '备注内容长度最多20个字符'
                  }
                  return true
                }
              })
                .then(({ value }) => {
                  postData.isSave = 1
                  postData.remark = value
                  this.$api.adPromotion.saveTagInfo(postData).then(res1 => {
                    if (res1.code == 0) {
                      this.$message({
                        showClose: true,
                        message: '标签包保存成功了！',
                        type: 'success'
                      })
                      this.getTagsInfo('')
                    } else {
                      this.$message({
                        showClose: true,
                        message: res1.message,
                        type: 'error'
                      })
                    }
                  })
                })
                .catch(() => {})
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消覆盖，请修改标签包名称'
              })
            })
        } else if (res.code == 7777) {
          this.$prompt('请输入备注内容', '提示', {
            confirmButtonText: '保存',
            cancelButtonText: '取消',
            inputValidator: function(value) {
              if (value.length > 20) {
                return '备注内容长度最多20个字符'
              }
              return true
            }
          })
            .then(({ value }) => {
              postData.isSave = 1
              postData.remark = value
              this.$api.adPromotion.saveTagInfo(postData).then(res2 => {
                if (res2.code == 0) {
                  this.$message({
                    showClose: true,
                    message: '标签包保存成功了！',
                    type: 'success'
                  })
                  this.getTagsInfo('')
                } else {
                  this.$message({
                    showClose: true,
                    message: res2.message,
                    type: 'error'
                  })
                }
              })
            })
            .catch(() => {})
        } else {
          this.$message({
            showClose: true,
            message: '保存标签包失败，请重试！',
            type: 'error'
          })
        }
      })
    },
    //自动生成标签包
    autoActionTag: function() {
      var ids = this.oldTags

      var selectIds = this.tagForm.domains.map(x => x['inputId'])

      if (this.tagForm.domains[0].tags.length <= 0) {
        this.tagForm.domains = []
      }

      this.oldTagOptions.forEach(
        function(item, index) {
          if (ids.includes(item.id) && !selectIds.includes(item.id)) {
            var num = this.tagForm.domains.length + 1
            this.tagForm.domains.push({
              label: '创意标签组-' + num,
              tags: item.tags,
              inputVisible: false,
              inputValue: '',
              inputTitle: item.name,
              inputId: item.id
            })
          }
        }.bind(this)
      )
    },
    //自动生成标题包
    autoActionTitle: function() {
      this.oldTitleSelectOptions.forEach(
        function(item, i) {
          if (item.id == this.oldTitleSelect) {
            var arr = item.titles

            while (item.titles.length < this.titleForm.info.length) {
              arr.push.apply(arr, item.titles)
            }

            this.titleForm.info.forEach(
              function(data, index) {
                this.titleForm.info[index].title = arr[index]
              }.bind(this)
            )
          }
        }.bind(this)
      )
    },
    //点击当前行选中
    clickCheckbox: function(row, column, event) {
      var index = this.product_options_new.indexOf(row)
      if (index != -1) {
        this.$refs.productRef.toggleRowSelection(row, false)
      } else {
        this.$refs.productRef.toggleRowSelection(row, true)
      }
    },
    //清空标题
    clearTitlesInfo: function() {
      this.titleForm.info = []
      this.titleList = []
    },
    //生成随机数
    randomString: function(e) {
      e = e || 32
      var t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678',
        a = t.length,
        n = ''
      for (i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
      return n
    },
    //提交广告
    actionAdver: function() {
      var newAdver = JSON.parse(JSON.stringify(this.multipleSelection))
      if (this.multipleSelection.length <= 0) {
        this.$message({
          showClose: true,
          message: '请先选择广告，然后提交',
          type: 'error'
        })
        return
      }
      newAdver.forEach(function(item, index) {
        delete item.campaign.audience.targetingName
      })
      this.$api.adPromotion.actionAdver(newAdver).then(res => {
        if (res.code == 0) {
          this.$message({
            showClose: true,
            message: '成功！加入投放队列！',
            type: 'success'
          })
          this.$router.replace('/task')
        }
      })
    },
    handleSelectionChangeView: function(val) {
      this.multipleSelection = val
    },
    //批量生成标题
    allTitleAction: function() {
      if (this.textarea) {
        var stringResult = this.textarea.split('\n')

        if (stringResult.length != this.totalNum) {
          this.$message({
            showClose: true,
            message: '批量设置的数量有误，请检查',
            type: 'error'
          })
          return
        } else {
          var datas = this.titleForm.info
          datas.forEach(function(item, index) {
            item.title = stringResult[index]
          })
        }
      } else {
        this.$message({
          showClose: true,
          message: '请先填写批量设置的标题内容',
          type: 'error'
        })
        return
      }
    },
    //预览计划
    viewAdver: function() {
      if (this.promotion_way == 'STANDARD') {
        if (
          JSON.stringify(this.adverList) == '{}' ||
          this.targetingList.targetingView.length <= 0 ||
          this.creativeList.length <= 0 ||
          this.tagList.length <= 0 ||
          this.titleList.length <= 0
        ) {
          this.$message({
            showClose: true,
            message: '请完善相关信息（计划,定向，创意，标签，标题不能为空）',
            type: 'error'
          })
          return
        }
      }
      if (this.promotion_way == 'SIMPLE') {
        if (
          JSON.stringify(this.adverList) == '{}' ||
          this.targetingList.targetingView.length <= 0 ||
          this.creativeList.length <= 0 ||
          this.titleList.length <= 0
        ) {
          this.$message({
            showClose: true,
            message: '请完善相关信息（计划,定向，创意，标题不能为空）',
            type: 'error'
          })
          return
        }
      }

      if (this.totalNum != this.titleList.length) {
        this.$message({
          showClose: true,
          message: '请完善标题内容，数量不一致',
          type: 'error'
        })
        return
      }

      var campaign = this.adverList
      var targetings = this.targetingList.targetingView
      var creatives = this.creativeList
      var tags = this.tagList
      var titles = this.titleList
      var viewTable = []
      var num = 0
      var order = this.num

      targetings.forEach(
        function(tar, t) {
          creatives.forEach(
            function(cre, c) {
              if (tags.length > 0) {
                tags.forEach(
                  function(tag, i) {
                    var infos = JSON.parse(JSON.stringify(campaign))
                    var creative = JSON.parse(
                      JSON.stringify(info['campaign']['creative_list'])
                    )
                    delete infos['campaign']['creative_list']

                    //赋值创意
                    infos['campaign'][cre['field']] = []
                    cre['info'].forEach(
                      function(item, p) {
                        var newInfo = JSON.parse(JSON.stringify(item.info))

                        if (cre['field'] == 'creative_list') {
                          newInfo['title_material'] = titles[num]
                          // 如果是短视频，则处理推广卡片
                          if (
                            campaign['campaign']['marketing_goal'] ==
                              'VIDEO_PROM_GOODS' &&
                            item['sourceType'] == 'VIDEO'
                          ) {
                            newInfo['promotion_card_material'] =
                              creative['promotion_card_material']
                          }
                        } else if (
                          cre['field'] == 'programmatic_creative_media_list'
                        ) {
                          // 如果是短视频并且是视频类型，则处理推广卡片
                          if (
                            campaign['campaign']['marketing_goal'] ==
                              'VIDEO_PROM_GOODS' &&
                            item['sourceType'] == 'VIDEO'
                          ) {
                            newInfo['programmatic_creative_card'] = {
                              promotion_card_title:
                                creative['promotion_card_material']['title'],
                              promotion_card_image_id:
                                creative['promotion_card_material']['image_id'],
                              promotion_card_action_button:
                                creative['promotion_card_material'][
                                  'action_button'
                                ],
                              promotion_card_button_smart_optimization:
                                creative['promotion_card_material'][
                                  'button_smart_optimization'
                                ],
                              promotion_card_selling_points:
                                creative['promotion_card_material'][
                                  'selling_points'
                                ]
                            }
                          }
                          infos['campaign'][
                            'programmatic_creative_title_list'
                          ] = titles[num]
                        }
                        infos['campaign'][cre['field']].push(newInfo)
                      }.bind(this)
                    )
                    //赋值标签
                    infos['campaign']['ad_keywords'] = tag['tags']
                    //生成广告组名称
                    var project = this.project ? this.project : '无项目'
                    var groupName =
                      this.returnTime('adg') +
                      project +
                      infos.campaign.delivery_setting.cpa_bid +
                      '——' +
                      this.info.views.user.nickname +
                      '-' +
                      this.randomString(4)
                    infos['adgroup']['campaign_name'] = groupName

                    //生成计划名称
                    infos['campaign']['name'] = this.returnStr(
                      infos.campaign.name,
                      infos.adgroup.marketing_goal,
                      tar['targetingName'],
                      infos.campaign.delivery_setting.external_action,
                      order,
                      cre['info'][0]['name']
                    )
                    order++

                    num++
                    //赋值人群定向
                    infos['campaign']['audience'] = tar['textInfo']

                    viewTable.push(JSON.parse(JSON.stringify(infos)))
                  }.bind(this)
                )
              } else {
                var infos = JSON.parse(JSON.stringify(campaign))
                var creative = JSON.parse(
                  JSON.stringify(infos['campaign']['creative_list'])
                )
                delete infos['campaign']['creative_list']
                //赋值创意
                infos['campaign'][cre['field']] = []
                cre['info'].forEach(
                  function(item, p) {
                    var newInfo = JSON.parse(JSON.stringify(item.info))
                    if (cre['field'] == 'creative_list') {
                      newInfo['title_material'] = titles[num]
                      // 如果是短视频，则处理推广卡片
                      if (
                        campaign['campaign']['marketing_goal'] ==
                          'VIDEO_PROM_GOODS' &&
                        item['sourceType'] == 'VIDEO'
                      ) {
                        newInfo['promotion_card_material'] =
                          creative['promotion_card_material']
                      }
                    } else if (
                      cre['field'] == 'programmatic_creative_media_list'
                    ) {
                      // 如果是短视频并且是视频类型，则处理推广卡片
                      if (
                        campaign['campaign']['marketing_goal'] ==
                          'VIDEO_PROM_GOODS' &&
                        item['sourceType'] == 'VIDEO'
                      ) {
                        newInfo['programmatic_creative_card'] = {
                          promotion_card_title:
                            creative['promotion_card_material']['title'],
                          promotion_card_image_id:
                            creative['promotion_card_material']['image_id'],
                          promotion_card_action_button:
                            creative['promotion_card_material'][
                              'action_button'
                            ],
                          promotion_card_button_smart_optimization:
                            creative['promotion_card_material'][
                              'button_smart_optimization'
                            ],
                          promotion_card_selling_points:
                            creative['promotion_card_material'][
                              'selling_points'
                            ]
                        }
                      }
                      infos['campaign']['programmatic_creative_title_list'] =
                        titles[num]
                    }
                    infos['campaign'][cre['field']].push(
                      JSON.parse(JSON.stringify(newInfo))
                    )
                  }.bind(this)
                )
                //生成广告组名称
                var project = this.project ? this.project : '无项目'
                var groupName =
                  this.returnTime('adg') +
                  project +
                  infos.campaign.delivery_setting.cpa_bid +
                  '——' +
                  this.info.views.user.nickname +
                  '-' +
                  this.randomString(4)
                infos['adgroup']['campaign_name'] = groupName
                //生成计划名称
                infos['campaign']['name'] = this.returnStr(
                  infos.campaign.name,
                  info.adgroup.marketing_goal,
                  tar['targetingName'],
                  infos.campaign.delivery_setting.external_action,
                  order,
                  cre['info'][0]['name']
                )
                order++
                num++
                //赋值人群定向
                infos['campaign']['audience'] = tar['textInfo']
                viewTable.push(infos)
              }
            }.bind(this)
          )
        }.bind(this)
      )
      this.viewTable = viewTable
    },
    returnStr: function(
      strr,
      marketing_goal,
      targetingName,
      external_action,
      order,
      sourceName
    ) {
      var patternYx = /\{营销目标\}/
      var patternZh = /\{转化目标\}/
      var patternDx = /\{定向包名\}/
      var patternSc = /\{素材名\}/
      var patternRq = /\{日期\}/
      var patternSj = /\{时间\}/
      var patternBh = /\{编号\}/
      var str = strr
      if (patternYx.test(str)) {
        var gg = ''
        if (marketing_goal == 'VIDEO_PROM_GOODS') {
          gg = '短视频带货'
        }
        if (marketing_goal == 'LIVE_PROM_GOODS') {
          gg = '直播带货'
        }
        str = str.replace(patternYx, gg)
      }
      if (patternDx.test(str)) {
        str = str.replace(patternDx, targetingName)
      }
      if (patternSc.test(str)) {
        str = str.replace(patternSc, sourceName)
      }
      if (patternZh.test(str)) {
        var zh = ''
        if (external_action == 'AD_CONVERT_TYPE_SHOPPING') {
          zh = '商品购买'
        }
        if (external_action == 'AD_CONVERT_TYPE_QC_FOLLOW_ACTION') {
          zh = '粉丝提升'
        }
        if (external_action == 'AD_CONVERT_TYPE_QC_MUST_BUY') {
          zh = '点赞评论'
        }
        if (external_action == 'AD_CONVERT_TYPE_LIVE_ENTER_ACTION') {
          zh = '进入直播间'
        }
        if (external_action == 'AD_CONVERT_TYPE_LIVE_CLICK_PRODUCT_ACTION') {
          zh = '直播间商品点击'
        }
        if (external_action == 'AD_CONVERT_TYPE_LIVE_SUCCESSORDER_ACTION') {
          zh = '直播间下单'
        }
        if (external_action == 'AD_CONVERT_TYPE_NEW_FOLLOW_ACTION') {
          zh = '直播间粉丝提升'
        }
        if (external_action == 'AD_CONVERT_TYPE_LIVE_COMMENT_ACTION') {
          zh = '直播间评论'
        }
        if (external_action == 'AD_CONVERT_TYPE_LIVE_SUCCESSORDER_PAY') {
          zh = '直播间成交'
        }
        str = str.replace(patternZh, zh)
      }

      if (patternRq.test(str)) {
        str = str.replace(patternRq, this.returnTime('cam'))
      }
      if (patternSj.test(str)) {
        str = str.replace(patternSj, this.returnTime('time'))
      }
      if (patternBh.test(str)) {
        str = str.replace(patternBh, order)
      }
      return str
    },
    returnTime: function(type) {
      var date = new Date()

      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minute =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var second =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      if (type == 'cam') {
        return month + '-' + day
      }
      if (type == 'adg') {
        return month + '' + day
      }

      if (type == 'time') {
        return hour + ':' + minute + ':' + second
      }
    },
    //清空创意
    clearCreative: function() {
      this.creativeList = {}
      this.sourceItem = []
    },
    //保存创意
    saveAdcreative: function() {
      var obj = JSON.parse(JSON.stringify(this.sourceItem))

      var info = []

      obj.forEach(function(item, index) {
        var arr = {}

        arr['field'] = item.field
        arr['top_img'] = item.top_img
        arr['info'] = []

        if (item.info.length > 0) {
          item.info.forEach(function(it, i) {
            arr.info.push(it)
          })
          info.push(arr)
        }
      })
      if (info.length <= 0) {
        this.$message({
          showClose: true,
          message: '创意素材不能为空请选择素材',
          type: 'error'
        })
        return
      } else {
        this.creativeList = info

        this.SourceDialog = false
      }
    },
    changeSelectIndex: function(index) {
      this.selectIndex = index
    },
    //清空组
    clearAdcreativeGroup: function(index) {
      this.sourceItem.splice(index, 1)

      this.selectIndex = this.sourceItem.length - 1
    },
    //清空单个素材
    clearAdcreativeOne(index, i) {
      this.sourceItem[index].info.splice(i, 1)
      //如果删除完毕单个的素材，则删除该组
      if (this.sourceItem[index].info.length == 0) {
        this.sourceItem.splice(index, 1)
        this.selectIndex = this.sourceItem.length - 1
      }
    },
    //添加素材组
    addSourceGroup: function() {
      var obj = {
        type: this.sourceItem[0].type,
        mode: this.sourceItem[0].mode,
        field: this.sourceItem[0].field,
        sourceType: this.sourceItem[0].sourceType,
        info: []
      }
      this.sourceItem.push(obj)
      this.selectIndex = this.sourceItem.length - 1
    },
    inArray: function() {
      if (
        this.bind_type.includes('OFFICIAL') ||
        this.bind_type.includes('SELF')
      ) {
        return true
      }
      return false
    },
    inZh: function() {
      if (
        this.adverForm.campaign.delivery_setting.external_action ==
          'AD_CONVERT_TYPE_QC_FOLLOW_ACTION' ||
        this.adverForm.campaign.delivery_setting.external_action ==
          'AD_CONVERT_TYPE_QC_MUST_BUY'
      ) {
        return true
      }
      return false
    },
    handleCurrentChangeSource: function(val) {
      this.getSourceList(val)
    },
    handleCloseVideo: function(done) {
      var videos = document.getElementsByTagName('video')
      for (var i = 0; i < videos.length; i++) {
        videos[i].pause()
      }
      done()
    },
    //判断视频类型
    checkValidateSource: function(sType, width, height) {
      //宽高比
      if (width > height) {
        var ww = width / 16
        var hh = height / ww
      }
      if (width < height) {
        var ww = width / 9
        var hh = height / ww
      }
      if (hh == 9) {
        // 横版视频和大图横图
        if (width < 1280 || width > 2560) {
          return {
            code: 10001,
            message: '横版素材类型宽度最小不能低于1280，最多不能大于2560'
          }
        }
        if (height < 720 || height > 1440) {
          return {
            code: 10001,
            message: '横版素材类型高度最小不能低于720，最多不能大于1440'
          }
        }

        if (sType == 'video') {
          return {
            code: 0,
            message: 'VIDEO_LARGE'
          }
        } else if ('image') {
          return {
            code: 0,
            message: 'LARGE'
          }
        }
      }

      if (hh == 16) {
        // 竖版视频和大图竖图
        if (width < 720 || width > 1440) {
          return {
            code: 10001,
            message: '竖版素材类型宽度最小不能低于720，最多不能大于1440'
          }
        }
        if (height < 1280 || height > 2560) {
          return {
            code: 10001,
            message: '竖版素材类型高度最小不能低于1280，最多不能大于2560'
          }
        }

        if (sType == 'video') {
          return {
            code: 0,
            message: 'VIDEO_VERTICAL'
          }
        } else if (sType == 'image') {
          return {
            code: 0,
            message: 'LARGE_VERTICAL'
          }
        }
      }
      var bb = width / height
      //小图
      if (bb.toFixed(2) == 1.52 && sType == 'image') {
        if (width < 456 || width > 1368) {
          return {
            code: 10001,
            message: '小图素材类型宽度最小不能低于456，最多不能大于1368'
          }
        }
        if (height < 300 || height > 900) {
          return {
            code: 10001,
            message: '小图素材类型高度最小不能低于300，最多不能大于900'
          }
        }
        return {
          code: 0,
          message: 'SMALL'
        }
      }
      // 穿山甲开屏图片
      if (bb.toFixed(2) == 0.56 && sType == 'image') {
        if (width < 1080 || width > 2160) {
          return {
            code: 10001,
            message: '小图素材类型宽度最小不能低于1080，最多不能大于2160'
          }
        }
        if (height < 1920 || height > 3840) {
          return {
            code: 10001,
            message: '小图素材类型高度最小不能低于1920，最多不能大于3840'
          }
        }
        return {
          code: 0,
          message: 'UNION_SPLASH'
        }
      }
      // 直播画面类型
      if (sType == 'image') {
        return {
          code: 0,
          message: 'AWEME_LIVE_ROOM'
        }
      }

      return {
        code: 10001,
        message: '视频宽高不符合要求或者类型有误'
      }
    },
    //抖音号赋值
    douyinHaoClick: function(val) {
      this.douying_options.forEach(
        function(item, index) {
          if (item.aweme_id == val) {
            this.bind_type = item.bind_type
          }
        }.bind(this)
      )
    },
    checkAdcreticeInfo: function(mode, item) {
      var obj = {
        type: '',
        name: '',
        mode: '',
        field: '',
        file: '',
        top_img: '',
        info: []
      }

      //短视频
      if (this.marketing_goal == 'VIDEO_PROM_GOODS') {
        //自定义
        if (
          this.adverForm.campaign.creative_material_mode == 'CUSTOM_CREATIVE'
        ) {
          if (this.searchForm.type == 'LOCAL') {
            if (item.type == 'video') {
              obj['type'] = 'vcl'
              obj['name'] = item.name
              obj['mode'] = mode
              obj['file'] = item.file
              obj['top_img'] = item.top_img
              obj['sourceType'] = 'VIDEO'
              obj['field'] = 'creative_list'
              obj['info'] = {
                image_mode: mode,
                video_material: {
                  video_id: item.id,
                  video_cover_id: item.id
                }
              }
            }
            if (item.type == 'image') {
              var ids = []
              ids.push(item.id)
              obj['type'] = 'vcl'
              obj['name'] = item.name
              obj['mode'] = mode
              obj['file'] = item.file
              obj['top_img'] = item.file
              obj['sourceType'] = 'IMAGE'
              obj['field'] = 'creative_list'
              obj['info'] = {
                image_mode: mode,
                image_material: {
                  image_ids: ids
                }
              }
            }
          } else {
            if (mode != 'VIDEO_VERTICAL') {
              this.$message({
                showClose: true,
                message: '抖音下视频只能使用竖版视频',
                type: 'error'
              })
              return
            }
            obj['type'] = 'vca'
            obj['name'] = item.name
            obj['mode'] = mode
            obj['file'] = item.url
            obj['top_img'] = item.video_cover_url
            obj['sourceType'] = 'VIDEO'
            obj['field'] = 'creative_list'
            obj['info'] = {
              image_mode: mode,
              video_material: {
                aweme_item_id: item.aweme_item_id
              }
            }
          }
        }
        //程序化
        if (
          this.adverForm.campaign.creative_material_mode ==
          'PROGRAMMATIC_CREATIVE'
        ) {
          if (this.searchForm.type == 'LOCAL') {
            if (item.type == 'video') {
              obj['type'] = 'vrl'
              obj['name'] = item.name
              obj['mode'] = mode
              obj['file'] = item.file
              obj['top_img'] = item.top_img
              obj['sourceType'] = 'VIDEO'
              obj['field'] = 'programmatic_creative_media_list'
              obj['info'] = {
                image_mode: mode,
                video_id: item.id,
                video_cover_id: item.id
              }
            }
            if (item.type == 'image') {
              var ids = []
              ids.push(item.id)
              obj['type'] = 'vrl'
              obj['name'] = item.name
              obj['mode'] = mode
              obj['file'] = item.file
              obj['top_img'] = item.file
              obj['sourceType'] = 'IMAGE'
              obj['field'] = 'programmatic_creative_media_list'
              obj['info'] = {
                image_mode: mode,
                image_ids: ids
              }
            }
          } else {
            this.$message({
              showClose: true,
              message: '程序化创意下不支持抖音号下视频',
              type: 'error'
            })
            return
          }
        }
      } else if (this.marketing_goal == 'LIVE_PROM_GOODS') {
        //自定义
        if (
          this.adverForm.campaign.creative_material_mode == 'CUSTOM_CREATIVE'
        ) {
          if (item.type != 'video') {
            this.$message({
              showClose: true,
              message: '直播带货自定义只支持视频素材类型',
              type: 'error'
            })
            return
          }
          if (this.searchForm.type == 'LOCAL') {
            obj['type'] = 'lcl'
            obj['name'] = item.name
            obj['mode'] = mode
            obj['file'] = item.file
            obj['top_img'] = item.top_img
            obj['sourceType'] = 'VIDEO'
            obj['field'] = 'creative_list'
            obj['info'] = {
              image_mode: mode,
              video_material: {
                video_id: item.id,
                video_cover_id: item.id
              }
            }
          } else {
            if (mode != 'VIDEO_VERTICAL') {
              this.$message({
                showClose: true,
                message: '抖音下视频智能使用竖版视频',
                type: 'error'
              })
              return
            }
            obj['type'] = 'lca'
            obj['name'] = item.name
            obj['mode'] = mode
            obj['file'] = item.url
            obj['top_img'] = item.video_cover_url
            obj['sourceType'] = 'VIDEO'
            obj['field'] = 'creative_list'
            obj['info'] = {
              image_mode: mode,
              video_material: {
                aweme_item_id: item.aweme_item_id
              }
            }
          }
        }
        //程序化
        if (
          this.adverForm.campaign.creative_material_mode ==
          'PROGRAMMATIC_CREATIVE'
        ) {
          if (this.searchForm.type == 'LOCAL') {
            obj['type'] = 'lpl'
            obj['name'] = item.name
            obj['mode'] = mode
            obj['file'] = item.file
            obj['top_img'] = item.top_img
            obj['sourceType'] = 'VIDEO'
            obj['field'] = 'programmatic_creative_media_list'
            obj['info'] = {
              image_mode: mode,
              video_id: item.id,
              video_cover_id: item.id
            }
          } else {
            this.$message({
              showClose: true,
              message: '程序化创意下不支持抖音号下视频',
              type: 'error'
            })
            return
          }
        }
      }
      return obj
    },
    //点击素材使用的方法
    changeCard: function(item) {
      if (this.sourceMax > 0) {
        var res = this.checkValidateSource(
          item.type,
          item.width - 0,
          item.height - 0
        )
        if (res.code != 0) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'error'
          })
          return
        }
        var mode = res.message
        var data = JSON.parse(
          JSON.stringify(this.checkAdcreticeInfo(mode, item))
        )
        var ii = this.selectIndex

        if (
          this.inZh() &&
          this.adverForm.campaign.creative_material_mode ==
            'PROGRAMMATIC_CREATIVE' &&
          this.marketing_goal == 'VIDEO_PROM_GOODS' &&
          data.sourceType == 'IMAGE'
        ) {
          this.$message({
            showClose: true,
            message:
              '【短视频带货】目标下的【程序化创意】，转化目标选择【粉丝提升】或【点赞评论】时，不支持图片素材',
            type: 'error'
          })
          return
        }
        if (
          !this.inArray() &&
          this.adverForm.campaign.creative_material_mode ==
            'PROGRAMMATIC_CREATIVE' &&
          this.marketing_goal == 'VIDEO_PROM_GOODS' &&
          data.sourceType == 'IMAGE'
        ) {
          this.$message({
            showClose: true,
            message:
              '【短视频带货】目标下的【程序化创意】，计划关联的抖音号类型不为【官方】或【自运营】时，不支持图片素材',
            type: 'error'
          })
          return
        }

        if (
          this.adverForm.campaign.creative_material_mode == 'CUSTOM_CREATIVE' &&
          this.marketing_goal == 'VIDEO_PROM_GOODS' &&
          this.promotion_way == 'SIMPLE' &&
          data.sourceType == 'IMAGE'
        ) {
          this.$message({
            showClose: true,
            message:
              '【短视频带货】目标下的【自定义创意】，推广类型为【极速版】时，不支持图片素材',
            type: 'error'
          })
          return
        }

        if (this.sourceItem[ii]) {
          if (this.sourceItem[ii].info.length >= this.sourceMax - 0) {
            var obj = {
              type: data.type,
              // 'mode':data.mode,
              field: data.field,
              // 'sourceType':data.sourceType,
              info: []
            }
            obj.info.push(data)
            this.sourceItem.push(obj)

            this.selectIndex = this.sourceItem.length - 1
          } else {
            this.sourceItem[ii].info.push(data)
          }
        } else {
          var obj = {
            type: data.type,
            // 'mode':data.mode,
            field: data.field,
            // 'sourceType':data.sourceType,
            info: []
          }
          obj.info.push(data)
          this.sourceItem.push(obj)
          this.selectIndex = 0
        }
      } else {
        this.$message({
          showClose: true,
          message: '当前创意形式不能添加素材，请重新选择',
          type: 'error'
        })
        return
      }
    },
    //预览
    viewVideo: function(item) {
      this.sourceView.SourceDialogVideoUrl = item.file
      this.sourceView.SourceDialogVideoCover = item.top_img
      this.sourceView.SourceDialogVideoSize = item.width + 'x' + item.height
      this.sourceView.SourceDialogVideoTime = item.createTime
      this.sourceView.SourceDialogVideoId = item.id
      this.SourceDialogVideo = true
    },
    clearSearch: function() {
      this.searchForm = {
        name: '',
        type: 'LOCAL',
        sourceType: 'video'
      }
    },
    //打开创意
    openSourceInfo: function() {
      if (JSON.stringify(this.adverList) == '{}') {
        this.$message({
          showClose: true,
          message: '请先完善计划中的内容，创意展现形式是必填项',
          type: 'error'
        })
        return
      }

      //短视频
      if (this.marketing_goal == 'VIDEO_PROM_GOODS') {
        //自定义
        if (
          this.adverForm.campaign.creative_material_mode == 'CUSTOM_CREATIVE'
        ) {
          if (this.promotion_way == 'STANDARD') {
            if (
              this.inArray() &&
              this.adverForm.campaign.creative_auto_generate == '1'
            ) {
              this.sourceMin = 1
              this.sourceMax = 7
              this.message = ''
            }

            if (
              this.inArray() &&
              this.adverForm.campaign.creative_auto_generate == '0'
            ) {
              this.sourceMin = 3
              this.sourceMax = 10
              this.message = '请至少添加1个竖版视频、1个横版视频、1个横版大图'
            }

            if (
              !this.inArray() &&
              this.adverForm.campaign.creative_auto_generate == '0'
            ) {
              this.sourceMin = 1
              this.sourceMax = 10
              this.message = ''
            }
          }
          if (this.promotion_way == 'SIMPLE') {
            if (
              this.inArray() &&
              this.adverForm.campaign.creative_auto_generate == '1'
            ) {
              this.sourceMin = 1
              this.sourceMax = 7
              this.message = ''
            }
            if (
              !this.inArray() &&
              this.adverForm.campaign.creative_auto_generate == '0'
            ) {
              this.sourceMin = 1
              this.sourceMax = 10
              this.message = ''
            }
          }
        }
        //程序化
        if (
          this.adverForm.campaign.creative_material_mode ==
          'PROGRAMMATIC_CREATIVE'
        ) {
          if (
            this.inArray() &&
            this.adverForm.campaign.creative_auto_generate == '0'
          ) {
            this.message = '请至少添加1个竖版视频、1个横版视频、1个横版大图'
          } else {
            this.message = ''
          }

          this.sourceMin = 1
          this.sourceMax = 9
        }
        //直播
      } else if (this.marketing_goal == 'LIVE_PROM_GOODS') {
        //自定义
        if (
          this.adverForm.campaign.creative_material_mode == 'CUSTOM_CREATIVE'
        ) {
          this.sourceMin = 1
          this.sourceMax = 10
        }
        //程序化
        if (
          this.adverForm.campaign.creative_material_mode ==
          'PROGRAMMATIC_CREATIVE'
        ) {
          this.sourceMin = 1
          this.sourceMax = 9
        }
      }
      this.SourceDialog = true
      this.getSourceList()
    },
    getSourceList: function(page) {
      var params = this.searchForm

      params['adverId'] = this.advertiser_id
      params['aweme_id'] = this.aweme_id
      if (this.marketing_goal == 'VIDEO_PROM_GOODS') {
        params['product_id'] = this.product_ids[0]
      }
      params['page'] = page ? page : 1
      params['prop'] = 'id'
      params['order'] = 'desc'
      this.$api.adPromotion.getSourceList(params).then(res => {
        this.sourceData = res.data
      })
    },
    //保存计划
    actionCampaignData: function() {
      this.$refs['campaignForm'].validate(
        function(valid) {
          if (valid) {
            var adverObj = JSON.parse(JSON.stringify(this.adverForm))
            if (this.isScheduleTime == 'NONE') {
              adverObj.campaign.delivery_setting.schedule_time =
                '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111'
            } else {
              adverObj.campaign.delivery_setting.schedule_time = this.adverForm.campaign.delivery_setting.schedule_time.replace(
                /,/g,
                ''
              )
            }

            if (
              this.adverForm.campaign.delivery_setting.video_schedule_type ==
                'SCHEDULE_START_END' ||
              this.adverForm.campaign.delivery_setting.live_schedule_type ==
                'SCHEDULE_START_END'
            ) {
              adverObj.campaign.delivery_setting.start_time =
                adverObj.campaign.delivery_setting.timeDuan[0]
              adverObj.campaign.delivery_setting.end_time =
                adverObj.campaign.delivery_setting.timeDuan[1]
            }
            if (this.adverForm.campaign.promotion_way == 'STANDARD') {
              adverObj.campaign.first_industry_id =
                adverObj.campaign.industry_ids[0]
              adverObj.campaign.second_industry_id =
                adverObj.campaign.industry_ids[1]
              adverObj.campaign.third_industry_id =
                adverObj.campaign.industry_ids[2]
            } else {
              delete adverObj.campaign.first_industry_id
              delete adverObj.campaign.second_industry_id
              delete adverObj.campaign.third_industry_id
            }
            delete adverObj.campaign.industry_ids
            delete adverObj.campaign.delivery_setting.timeDuan

            if (this.marketing_goal == 'VIDEO_PROM_GOODS') {
              delete adverObj.campaign.delivery_setting.live_schedule_type
              delete adverObj.campaign.delivery_setting.schedule_fixed_range
            }
            if (this.marketing_goal == 'LIVE_PROM_GOODS') {
              delete adverObj.campaign.delivery_setting.video_schedule_type
              delete adverObj.campaign.product_ids
              delete adverObj.campaign.creative_auto_generate
            }
            if (
              adverObj.campaign.delivery_setting.live_schedule_type ==
                'SCHEDULE_FROM_NOW' ||
              adverObj.campaign.delivery_setting.video_schedule_type ==
                'SCHEDULE_FROM_NOW'
            ) {
              delete adverObj.campaign.delivery_setting.start_time
              delete adverObj.campaign.delivery_setting.end_time
            }
            if (
              adverObj.campaign.delivery_setting.live_schedule_type !=
              'SCHEDULE_TIME_FIXEDRANGE'
            ) {
              delete adverObj.campaign.delivery_setting.schedule_fixed_range
            } else {
              delete adverObj.campaign.delivery_setting.start_time
              delete adverObj.campaign.delivery_setting.end_time
              delete adverObj.campaign.delivery_setting.schedule_time
            }
            if (
              adverObj.campaign.delivery_setting.smart_bid_type !=
              'SMART_BID_CUSTOM'
            ) {
              delete adverObj.campaign.delivery_setting.cpa_bid
            }
            // console.log(adverObj)
            this.adverList = adverObj
            this.campaignFormVisiable = false
          }
        }.bind(this)
      )
    },
    //获取焦点
    handleInputBlur: function(event) {
      var obj = event.srcElement ? event.srcElement : event.target
      if (obj.selectionStart && obj.selectionStart != 'undefind') {
        this.selectionStart = obj.selectionStart
      }
    },
    updateIsShow: function(index) {
      this.titleForm.info[index].isShow = this.titleForm.info[index].isShow
        ? false
        : true
    },

    addTags: function(isType) {
      this.$refs['titleForm'].validate(
        function(valid) {
          if (valid) {
            var newTitleForm = JSON.parse(JSON.stringify(this.titleForm.info))
            var titleData = []
            var error = []
            var numError = []
            var regex3 = /\{(.+?)\}/g

            var words = {}
            this.title_options.forEach(function(item, i) {
              words['{' + item.name + '}'] = {
                word_id: item.id,
                dict_name: item.name,
                default_word: item.default_word
              }
            })
            var tts = []
            newTitleForm.forEach(
              function(item, i) {
                if (
                  this.adverForm.campaign.creative_material_mode ==
                  'CUSTOM_CREATIVE'
                ) {
                  //如果是要保存标题宝
                  if (isType == 'SAVE') {
                    //调取接口保存标题
                    tts.push(item.title)
                  } else {
                    var textNames = item.title.match(regex3)
                    var ll = {
                      title: item.title,
                      dynamic_words: []
                    }
                    if (textNames != null && textNames.length > 0) {
                      if (textNames.length > 2) {
                        error.push(1)
                      }
                      textNames.forEach(function(na, i) {
                        ll.dynamic_words.push(words[na])
                      })
                    }
                    titleData.push(ll)
                  }
                } else if (
                  this.adverForm.campaign.creative_material_mode ==
                  'PROGRAMMATIC_CREATIVE'
                ) {
                  var stringResult = item.title.split('\n')
                  var newData = []
                  if (
                    stringResult.length > 9 &&
                    this.marketing_goal == 'VIDEO_PROM_GOODS'
                  ) {
                    numError.push('短视频标题组合最多9条')
                  }
                  if (
                    stringResult.length > 10 &&
                    this.marketing_goal == 'LIVE_PROM_GOODS'
                  ) {
                    numError.push('直播带货标题组合最多10条')
                  }
                  //如果是要保存标题宝
                  if (isType == 'SAVE') {
                    stringResult.forEach(function(da, d) {
                      //调取接口保存标题
                      tts.push(da)
                    })
                  } else {
                    stringResult.forEach(function(da, d) {
                      var ll = {
                        title: da,
                        dynamic_words: []
                      }
                      var textNames = da.match(regex3)

                      if (textNames != null && textNames.length > 0) {
                        if (textNames.length > 2) {
                          error.push(1)
                        }
                        textNames.forEach(function(na, i) {
                          ll.dynamic_words.push(words[na])
                        })
                      }
                      newData.push(ll)
                    })
                    titleData.push(newData)
                  }
                }
              }.bind(this)
            )
            if (isType != 'SAVE') {
              if (error.length <= 0 && numError.length <= 0) {
                this.titledDawer = false
                this.titleList = titleData
              } else {
                if (error.length > 0) {
                  this.$message({
                    showClose: true,
                    message: '每个标题最多两个词包',
                    type: 'warning'
                  })
                  return
                }
                if (numError.length > 0) {
                  this.$message({
                    showClose: true,
                    message: numError[0],
                    type: 'warning'
                  })
                  return
                }
              }
            } else {
              if (!this.oldTitleName) {
                this.$message({
                  showClose: true,
                  message: '如需保存标题包请填写包名',
                  type: 'warning'
                })
                return
              }
              var postData = {
                name: this.oldTitleName,
                titles: tts,
                advertiser_id: this.advertiser_id,
                remark: '',
                isSave: ''
              }
              //首次查询标签包名称是否存在
              this.$api.adPromotion.addTags(postData).then(res => {
                if (res.code == 9999) {
                  this.$confirm('该标题包名已存在, 是否覆盖?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  })
                    .then(() => {
                      this.$prompt('请输入备注内容', '提示', {
                        confirmButtonText: '保存',
                        cancelButtonText: '取消',
                        inputValidator: function(value) {
                          if (value.length > 20) {
                            return '备注内容长度最多20个字符'
                          }
                          return true
                        }
                      })
                        .then(({ value }) => {
                          postData.isSave = 1
                          postData.remark = value
                          this.$api.adPromotion.addTags(postData).then(res1 => {
                            if (res1.code == 0) {
                              this.$message({
                                showClose: true,
                                message: '标题包保存成功了！',
                                type: 'success'
                              })
                              this.getTitleList('')
                            } else {
                              this.$message({
                                showClose: true,
                                message: res1.message,
                                type: 'error'
                              })
                            }
                          })
                        })
                        .catch(() => {})
                    })
                    .catch(() => {
                      this.$message({
                        type: 'info',
                        message: '已取消覆盖，请修改标题包名称'
                      })
                    })
                } else if (res.code == 7777) {
                  this.$prompt('请输入备注内容', '提示', {
                    confirmButtonText: '保存',
                    cancelButtonText: '取消',
                    inputValidator: function(value) {
                      if (value.length > 20) {
                        return '备注内容长度最多20个字符'
                      }
                      return true
                    }
                  })
                    .then(({ value }) => {
                      postData.isSave = 1
                      postData.remark = value
                      this.$api.adPromotion.addTags(postData).then(res2 => {
                        if (res2.code == 0) {
                          this.$message({
                            showClose: true,
                            message: '标题包保存成功了！',
                            type: 'success'
                          })
                          this.getTitleList('')
                        } else {
                          this.$message({
                            showClose: true,
                            message: res2.message,
                            type: 'error'
                          })
                        }
                      })
                    })
                    .catch(() => {})
                } else {
                  this.$message({
                    showClose: true,
                    message: '保存标题包失败，请重试！',
                    type: 'error'
                  })
                }
              })
            }
          }
        }.bind(this)
      )
    },
    //添加词包
    addTagsWords: function(index, item) {
      var regex3 = /\{(.+?)\}/g

      //自定义创意
      if (this.adverForm.campaign.creative_material_mode == 'CUSTOM_CREATIVE') {
        var thisCount = 0
        this.titleForm.info[index].title.replace(regex3, function(m, i) {
          //m为找到的{xx}元素、i为索引
          thisCount++
        })
        if (thisCount >= 2) {
          this.$message({
            showClose: true,
            message: '最多两个词包',
            type: 'warning'
          })
          return
        }
      }

      var str = '{' + item.name + '}'

      var num = this.titleForm.info[index].title.indexOf(str)
      if (num != -1) {
        var substr = this.titleForm.info[index].title.substr(num, str.length)
        this.titleForm.info[index].title = this.titleForm.info[
          index
        ].title.replace(substr, '')
      } else {
        var id = this.selectionStart
        if (id < this.titleForm.info[index].title.length) {
          //光标之前内容
          var strFront = this.titleForm.info[index].title.substring(0, id)
          var strBehind = this.titleForm.info[index].title.substring(
            id,
            this.titleForm.info[index].title.length
          )
          this.titleForm.info[index].title = strFront + str + strBehind
        } else {
          this.titleForm.info[index].title += str
        }
        // //赋值词包信息
        // this.titleForm.info[index].dynamic_words.push({'word_id':item.id,'dict_name':item.name,'default_word':item.default_word});
      }
    },
    //打开标题
    openTitle: function() {
      var titles = []
      for (var i = 0; i < this.totalNum; i++) {
        titles.push({
          title: '',
          isShow: false
          // dynamic_index:'',
          // dynamic_words:[]
        })
      }
      this.titleForm.info = titles
      this.getTitleList()
      this.getWordsInfo()
      this.titledDawer = true
    },
    getWordsInfo: function() {
      this.$api.adPromotion
        .getWordsInfo({
          adverId: this.advertiser_id
        })
        .then(res => {
          this.title_options = res
        })
    },
    addTagView: function() {
      var pp = []
      this.tagForm.domains.forEach(function(item, index) {
        if (item.tags.length <= 0) {
          pp.push(1)
        }
      })
      if (pp.length > 0) {
        this.$message({
          showClose: true,
          message: '标签不能为空！',
          type: 'warning'
        })
        return
      }
      this.tagList = JSON.parse(JSON.stringify(this.tagForm.domains))
      this.drawer = false
    },
    //清空标题
    clearTags: function() {
      this.titleList = []
      this.titleForm = {
        info: []
      }
    },
    //清空tag
    clearTag: function() {
      this.tagList = []
      this.tagForm = {
        domains: [
          {
            label: '创意标签组-1',
            inputVisible: false,
            inputValue: '',
            inputTitle: '',
            inputId: '',
            tags: []
          }
        ]
      }
    },
    //清除一条title
    clearOneTitle: function(index) {
      this.titleList.splice(index, 1)
      this.titleForm.info.splice(index, 1)
    },
    //清除一条tag
    clearOneTag: function(index) {
      this.tagList.splice(index, 1)
      this.tagForm.domains.splice(index, 1)
    },
    //打开标签
    openTag: function() {
      this.drawer = true
      this.getTagsInfo('')
    },
    //获取标题包内容
    getTitleList: function(query) {
      if (!query) {
        query = ''
      }
      this.$api.adPromotion
        .getTitleList({
          advertiser_id: this.advertiser_id,
          query: query
        })
        .then(res => {
          if (res.code == 0) {
            this.oldTitleSelectOptions = res.data
          }
        })
    },
    //获取标签列表
    getTagsInfo: function(query) {
      this.$api.adPromotion
        .getTagsInfo({
          advertiser_id: this.advertiser_id,
          query: query
        })
        .then(res => {
          if (res.code == 0) {
            this.oldTagOptions = res.data
          }
        })
    },
    delTagsData: function(index) {
      this.tagForm.domains.splice(index, 1)
    },
    addTagsData: function(index) {
      var num = this.tagForm.domains.length + 1
      this.tagForm.domains.push({
        label: '创意标签组-' + num,
        tags: [],
        inputVisible: false,
        inputValue: '',
        inputTitle: '',
        inputId: ''
      })
    },
    handleClose(index, tag) {
      this.tagForm.domains[index].tags.splice(
        this.tagForm.domains[index].tags.indexOf(tag),
        1
      )
    },
    showInput(index) {
      this.tagForm.domains[index].inputVisible = true
    },
    handleInputConfirm(index) {
      let inputValue = this.tagForm.domains[index].inputValue
      if (this.tagForm.domains[index].tags.length > 20) {
        this.$message({
          showClose: true,
          message: '每组标签最多20个！',
          type: 'warning'
        })
        return
      }
      if (
        inputValue &&
        this.tagForm.domains[index].tags.indexOf(inputValue) == -1
      ) {
        this.tagForm.domains[index].tags.push(inputValue)
      }
      this.tagForm.domains[index].inputVisible = false
      this.tagForm.domains[index].inputValue = ''
    },
    containerHide: function() {
      this.containerShow = !this.containerShow
    },
    //动态更新人群状态
    updateDesabled: function(val, text) {
      var data = this[text]
      data.forEach(
        function(item, index) {
          if (val.indexOf(item.value) != -1) {
            this.$set(data, index, {
              label: item.label,
              value: item.value,
              status: item.status,
              disabled: true
            })
          } else {
            this.$set(data, index, {
              label: item.label,
              value: item.value,
              status: item.status,
              disabled: false
            })
          }
        }.bind(this)
      )
    },
    //更具行为类型获取类目关键词
    actionSceneClick: function(val) {
      this.getActionScene()
      this.getInterestCategories()
    },
    //获取兴趣分类
    getInterestCategories: function() {
      this.$api.adPromotion
        .getInterestCategories({
          adverId: this.advertiser_id
        })
        .then(res => {
          this.interest_categories_options = res
        })
    },
    //获取兴趣关键词
    getInterestWords: function(val) {
      this.$api.adPromotion
        .getInterestWords({
          adverId: this.advertiser_id,
          query_words: val
        })
        .then(res => {
          this.interest_words_options = res
        })
    },
    //获取关键词
    getActionWords: function(val) {
      this.$api.adPromotion
        .getActionWords({
          adverId: this.advertiser_id,
          action_scene: this.targetingForm.action_scene,
          action_days: this.targetingForm.action_days,
          query_words: val
        })
        .then(res => {
          this.action_words_options = res
        })
    },
    //获取行为类目
    getActionScene: function() {
      this.$api.adPromotion
        .getActionScene({
          adverId: this.advertiser_id,
          action_scene: this.targetingForm.action_scene,
          action_days: this.targetingForm.action_days
        })
        .then(res => {
          this.action_categories_options = res
        })
    },
    //获取分类
    getCategoriesInfo: function() {
      this.$api.adPromotion
        .getCategoriesInfo({
          adverId: this.advertiser_id
        })
        .then(res => {
          this.fan_categories_options = res
        })
    },
    //获取抖音达人
    getAccountsInfo: function() {
      this.$api.adPromotion
        .getAccountsInfo({
          adverId: this.advertiser_id
        })
        .then(res => {
          this.fan_accounts_options = res
        })
    },
    //获取人群信息
    getRetargetingInfo: function() {
      this.$api.adPromotion
        .getRetargetingInfo({
          adverId: this.advertiser_id
        })
        .then(res => {
          this.retargeting_options = res
          this.retargeting_other_options = res
        })
    },
    //城市叶子节点获取
    clickNods: function(nodes) {
      var ids = []
      nodes.forEach(function(item, index) {
        if (targetingForm.district == 'CITY' && ids.indexOf(item[0]) == -1) {
          ids.push(item[0])
        } else if (
          targetingForm.district == 'COUNTY' &&
          ids.indexOf(item[2]) == -1
        ) {
          ids.push(item[2])
        }
      })

      return ids
    },
    getCityJson: function() {
      this.$api.adPromotion.getCityJson().then(res => {
        this.city_options = res
      })
    },
    //打开定向
    openTargetingDrawer: function() {
      this.innerDrawer = true
      this.targetingType = 'add'
      this.getCityJson()
      this.getCategoriesInfo()
      this.getAccountsInfo()
      this.getRetargetingInfo()
    },
    //添加定向
    addTargeting: function() {
      this.$refs['targetingForm'].validate(
        function(valid) {
          if (valid) {
            var aoptions = []
            var ioptions = []
            if (this.targetingForm.action_words.length > 0) {
              this.action_words_options.forEach(
                function(item, i) {
                  if (this.targetingForm.action_words.indexOf(item.id) != -1) {
                    aoptions.push(item)
                  }
                }.bind(this)
              )
            }
            if (this.targetingForm.interest_words.length > 0) {
              this.interest_words_options.forEach(
                function(item, i) {
                  if (
                    this.targetingForm.interest_words.indexOf(item.id) != -1
                  ) {
                    ioptions.push(item)
                  }
                }.bind(this)
              )
            }
            this.$api.adPromotion
              .addTargeting({
                adverId: this.advertiser_id,
                info: this.targetingForm,
                marketing_goal: this.marketing_goal,
                promotion_way: this.promotion_way,
                action_words: aoptions,
                interest_words: ioptions
              })
              .then(res => {
                if (res.code === 0) {
                  //重新获取定向
                  this.getTargetingInfo()
                  this.innerDrawer = false
                  this.$message({
                    showClose: true,
                    message: '添加定向成功',
                    type: 'success'
                  })
                }
              })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },
    //打开编辑定向
    editTargetingData: function(item) {
      this.targetingId = item.id
      this.targetingType = 'edit'
      this.innerDrawer = true
      this.targetingId = item.id
      this.targetingForm = item.textInfo

      this.action_words_options = item.action_words
      this.interest_words_options = item.interest_words
      this.getCityJson()
      this.getCategoriesInfo()
      this.getAccountsInfo()
      this.getRetargetingInfo()
      this.getActionScene()
      this.getInterestCategories()
    },
    //编辑定向
    editTargeting: function() {
      this.$refs['targetingForm'].validate(
        function(valid) {
          if (valid) {
            this.innerDrawer = false
            this.$api.adPromotion
              .editTargeting({
                id: this.targetingId,
                info: this.targetingForm
              })
              .then(res => {
                if (res.code === 0) {
                  var data = this.targetingData.data
                  data.forEach(
                    function(item, index) {
                      if (item.id == res.data['id']) {
                        this.$set(data, index, res.data)
                      }
                    }.bind(this)
                  )
                  this.$message({
                    showClose: true,
                    message: '修改定向成功',
                    type: 'success'
                  })
                }
              })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },
    //删除定向
    deleteTargeting: function(item) {
      this.$api.adPromotion
        .deleteTargeting({
          id: item.id
        })
        .then(res => {
          if (res.code === 0) {
            this.getTargetingInfo()
          } else {
            this.$message({
              showClose: true,
              message: '删除失败',
              type: 'warning'
            })
          }
        })
    },
    //清除定向
    clearTargeting: function() {
      this.targetingList.targetingView = []
      this.targetingList.targetingInfo = []
    },
    //清除一条
    clearOne: function(item) {
      var index = this.targetingList.targetingView.indexOf(item)
      var indexId = this.targetingList.targetingInfo.indexOf(item.id)
      if (index != -1) {
        this.targetingList.targetingView.splice(index, 1)
      }
      if (indexId != -1) {
        this.targetingList.targetingInfo.splice(indexId, 1)
      }
    },
    handleCurrentChangeTargeting: function(val) {
      this.getTargetingInfo(val)
    },
    //保存定向
    actionTargetingData: function() {
      if (this.targetingList.targetingInfo.length <= 0) {
        this.$message({
          showClose: true,
          message: '请填写正确的信息！',
          type: 'warning'
        })
        return
      }

      var data = this.targetingData.data
      this.targetingList.targetingView = []
      data.forEach(
        function(item, index) {
          if (this.targetingList.targetingInfo.indexOf(item.id) != -1) {
            var targetingObj = JSON.parse(JSON.stringify(item))
            if (targetingObj.textInfo.audience_mode == 'AUTO') {
              delete targetingObj.textInfo.district
              delete targetingObj.textInfo.city
              delete targetingObj.textInfo.location_type
              delete targetingObj.textInfo.gender
              delete targetingObj.textInfo.age
              delete targetingObj.textInfo.aweme_fan_behaviors
              delete targetingObj.textInfo.aweme_fan_behaviors_days
              delete targetingObj.textInfo.aweme_fan_categories
              delete targetingObj.textInfo.aweme_fan_accounts
            }
            if (this.promotion_way != 'STANDARD') {
              delete targetingObj.textInfo.auto_extend_enabled
              delete targetingObj.textInfo.auto_extend_targets
              delete targetingObj.textInfo.platform
              delete targetingObj.textInfo.smart_interest_action
              delete targetingObj.textInfo.action_scene
              delete targetingObj.textInfo.action_days
              delete targetingObj.textInfo.action_categories
              delete targetingObj.textInfo.action_words
              delete targetingObj.textInfo.interest_categories
              delete targetingObj.textInfo.interest_words
              delete targetingObj.textInfo.ac
              delete targetingObj.textInfo.retargeting_tags_include
              delete targetingObj.textInfo.retargeting_tags_exclude
              delete targetingObj.textInfo.live_platform_tags
            }
            if (targetingObj.textInfo.auto_extend_enabled == 0) {
              delete targetingObj.textInfo.auto_extend_targets
            }
            if (targetingObj.textInfo.smart_interest_action == 'RECOMMEND') {
              delete targetingObj.textInfo.action_days
              delete targetingObj.textInfo.action_categories
              delete targetingObj.textInfo.action_words
              delete targetingObj.textInfo.interest_categories
              delete targetingObj.textInfo.interest_words
              delete targetingObj.textInfo.interest_words
            }
            if (
              targetingObj.textInfo.audience_mode == 'CUSTOM' &&
              targetingObj.textInfo.city &&
              targetingObj.textInfo.city.length > 0
            ) {
              var city = targetingObj.textInfo.city
              var cityids = []
              //重新整理参数
              city.forEach(function(c, i) {
                cityids.push(c[c.length - 1])
              })
              targetingObj.textInfo.city = cityids
            }

            if (
              targetingObj.textInfo.audience_mode == 'CUSTOM' &&
              targetingObj.textInfo.aweme_fan_categories &&
              targetingObj.textInfo.aweme_fan_categories.length > 0
            ) {
              var categories = targetingObj.textInfo.aweme_fan_categories
              var cateids = []
              categories.forEach(function(c, i) {
                cateids.push(c[c.length - 1])
              })
              targetingObj.textInfo.aweme_fan_categories = cateids
            }

            if (
              this.promotion_way == 'STANDARD' &&
              targetingObj.textInfo.smart_interest_action == 'CUSTOM' &&
              targetingObj.textInfo.action_categories &&
              targetingObj.textInfo.action_categories.length > 0
            ) {
              var actions = targetingObj.textInfo.action_categories
              var aids = []
              actions.forEach(function(c, i) {
                aids.push(c[c.length - 1])
              })
              targetingObj.textInfo.action_categories = aids
            }

            if (
              this.promotion_way == 'STANDARD' &&
              targetingObj.textInfo.smart_interest_action == 'CUSTOM' &&
              targetingObj.textInfo.interest_categories &&
              targetingObj.textInfo.interest_categories.length > 0
            ) {
              var interests = targetingObj.textInfo.interest_categories
              var iids = []
              interests.forEach(function(c, i) {
                iids.push(c[c.length - 1])
              })
              targetingObj.textInfo.interest_categories = iids
            }

            if (targetingObj.textInfo.platform) {
              var ss = []
              ss.push(targetingObj.textInfo.platform)
              targetingObj.textInfo.platform = ss
            } else {
              var ss = []
              targetingObj.textInfo.platform = ss
            }
            // if(targetingObj.textInfo.retargeting_tags_include.length > 0){
            //     targetingObj.textInfo.retargeting_tags_include.map(function(item){
            //         console.log(item - 0)
            //         return parseInt(item - 0);
            //     })

            // }
            //  if(targetingObj.textInfo.retargeting_tags_exclude.length > 0){
            //      targetingObj.textInfo.retargeting_tags_exclude.map(function(item){
            //         console.log(item - 0)
            //         return item - 0;
            //     })
            // }
            this.targetingList.targetingView.push(targetingObj)
          }
        }.bind(this)
      )
      // console.log(this.targetingList);
      //
      this.targetingFormVisiable = false
    },
    //定向多选
    handleTargetingChange: function(vals) {
      var ids = vals.map(x => x['id'])
      this.targetingList.targetingInfo = ids
    },
    //获取定向列表
    getTargetingInfo: function(page) {
      this.$api.adPromotion
        .getTargetingInfo({
          guestId: this.advertiser_id,
          name: this.targetingList.name,
          marketing_goal: this.marketing_goal,
          promotion_way: this.promotion_way,
          page: page ? page : this.targetingData.current_page,
          prop: 'id',
          order: 'desc'
        })
        .then(res => {
          if (res.code === 0) {
            this.targetingData = res.data
          }
        })
    },
    //打开定向
    openTargeting: function() {
      this.getTargetingInfo()
      this.targetingFormVisiable = true
    },
    // 动态添加
    addInputInfo: function() {
      var num = this.input.length
      this.input.push('商家倾情推荐' + num)
    },
    //动态删除
    deleteInputInfo: function(item) {
      var index = this.input.indexOf(item)
      if (index !== -1) {
        this.input.splice(index, 1)
      }
    },
    clickText: function(num) {
      if (this.hasSelectList.indexOf(num) == -1) {
        this.hasSelectList.push(num)
      } else {
        var index = this.hasSelectList.indexOf(num)
        this.hasSelectList.splice(index, 1)
      }
    },
    //选择通配符
    tongpeiSelect: function() {
      this.dialogTableVisible = false
    },
    handleTongpeiChange: function(vals) {
      if (this.rowSelectFlag) {
        return
      }
      if (vals.length > 0) {
        var ids = vals.map(x => x['id'])

        this.hasSelectList = ids
      } else {
        this.hasSelectList = ['6', '7', '8']
      }
    },
    //插入更多
    insertInfo: function() {
      this.dialogTableVisible = true
      //检测一遍input内容有没有误删的，如果有则按误删除的
      var patternYin = /\{营销目标\}/
      var patternElem = /\{转化目标\}/
      var patternTar = /\{定向包名\}/
      var patternSour = /\{素材名\}/
      var patternTime = /\{日期\}/
      var patternStr = /\{时间\}/
      var patternOrder = /\{编号\}/

      var name = this.adverForm.campaign.name

      if (!patternYin.test(name) && this.hasSelectList.indexOf('1') != -1) {
        var index = this.hasSelectList.indexOf('1')
        this.hasSelectList.splice(index, 1)
      }
      if (!patternElem.test(name) && this.hasSelectList.indexOf('2') != -1) {
        var index = this.hasSelectList.indexOf('2')
        this.hasSelectList.splice(index, 1)
      }
      if (!patternTar.test(name) && this.hasSelectList.indexOf('3') != -1) {
        var index = this.hasSelectList.indexOf('3')
        this.hasSelectList.splice(index, 1)
      }
      if (!patternSour.test(name) && this.hasSelectList.indexOf('4') != -1) {
        var index = this.hasSelectList.indexOf('4')
        this.hasSelectList.splice(index, 1)
      }
      if (!patternTime.test(name) && this.hasSelectList.indexOf('5') != -1) {
        var index = this.hasSelectList.indexOf('5')
        this.hasSelectList.splice(index, 1)
      }
      if (!patternStr.test(name) && this.hasSelectList.indexOf('6') != -1) {
        var index = this.hasSelectList.indexOf('6')
        this.hasSelectList.splice(index, 1)
      }
      if (!patternOrder.test(name) && this.hasSelectList.indexOf('7') != -1) {
        var index = this.hasSelectList.indexOf('7')
        this.hasSelectList.splice(index, 1)
      }

      this.$nextTick(() => {
        //加锁防止 选中事件触发
        this.rowSelectFlag = true
        this.gridData.forEach(
          function(item, index) {
            if (this.hasSelectList.indexOf(item.id) != -1) {
              this.$refs.tonpeiTable.toggleRowSelection(item, true)
            } else {
              this.$refs.tonpeiTable.toggleRowSelection(item, false)
            }
          }.bind(this)
        )
        //解锁
        this.rowSelectFlag = false
      })
    },
    //日期事件
    scheduleTime: function() {
      if (
        this.adverForm.campaign.delivery_setting.live_schedule_type ==
          'SCHEDULE_FROM_NOW' ||
        this.adverForm.campaign.delivery_setting.video_schedule_type ==
          'SCHEDULE_FROM_NOW'
      ) {
        this.adverForm.campaign.delivery_setting.start_time = ''
        this.adverForm.campaign.delivery_setting.end_time = ''
      }
    },
    //时间段事件
    timeClick: function() {
      if (this.isScheduleTime == 'NONE') {
        this.adverForm.campaign.delivery_setting.schedule_time = ''
      } else if (this.isScheduleTime == 'ONLY') {
        this.scheduleTimeVisible = true
      }
    },
    //价格赋值
    priceTo: function(price) {
      this.adverForm.campaign.delivery_setting.budget = price
    },
    //打开计划抽屉
    openCampaign: function() {
      this.campaignFormVisiable = true
      this.remoteMethodTemplate('')
      this.getIndustry()
    },
    //获取行业
    getIndustry: function(val) {
      this.$api.adPromotion
        .getIndustry({
          adverId: this.advertiser_id
        })
        .then(res => {
          this.industry_options = res
        })
    },
    //全选
    handleSelectionChange: function(vals) {
      if (vals.length > 1) {
        this.$message({
          showClose: true,
          message: '目前最多只可以选择一件商品',
          type: 'warning'
        })
        this.$refs.productRef.clearSelection()
      } else {
        this.product_ids_new = vals.map(x => x['id'])
        var arr = []
        vals.forEach(function(item, index) {
          arr.push({
            label: item.name,
            value: item.id,
            url: item.img
          })
        })
        this.product_options_new = arr
      }
    },
    //保存商品
    saveProduct: function() {
      //请求商品主图ID
      this.$api.adPromotion
        .saveProduct({
          advertiser_id: this.advertiser_id,
          product_id: this.product_options_new[0]['value'],
          url: this.product_options_new[0]['url']
        })
        .then(res => {
          if (res.code === 0) {
            //赋值商品主图
            this.adverForm.campaign.creative_list.promotion_card_material.image_id =
              res.data.img_id

            this.productData.data.forEach(
              function(item, i) {
                if (this.product_options_new[0]['value'] == item.id) {
                  this.productImg = item.img
                }
              }.bind(this)
            )
            // this.productImg = res.data.url;

            this.product_options = this.product_options_new
            this.product_ids = this.product_ids_new

            this.productFormVisiable = false

            //清空临时数据
            this.productQuery = ''
            this.product_options_new = []
            this.product_ids_new = []
          }
        })
    },
    //关闭商品
    closeProduct: function() {
      this.productQuery = ''
      this.product_options_new = []
      this.product_ids_new = []
    },
    //取消选择
    canelSelect: function() {
      this.$refs.productRef.clearSelection()
      this.product_options_new = []
      this.product_ids_new = []
      this.productFormVisiable = false
    },
    //翻页
    handleCurrentChange: function(val) {
      this.handleSearch(val)
    },
    // 打开商品抽屉
    openProductDrawer: function() {
      //  失去焦点
      this.$refs['pro'].blur()
      this.productData = {
        total_number: 0,
        page_size: 15,
        page: 1,
        last_page: 0,
        data: []
      }
      this.getProductInfo()
      this.productFormVisiable = true
    },
    //刷新商品列表
    refeshProduct: function() {
      this.product_options = []
      this.product_ids = []
      this.getProductInfo()
    },
    // 获取账户信息
    getAdvertiserInfo: function(query) {
      this.$api.adPromotion
        .getAdvertiserInfo({
          mediaId: localStorage.getItem('mediaId'),
          query: query
        })
        .then(res => {
          if (res.code === 0) {
            this.advertiser_options = res.data
          }
        })
    },
    // 获取抖音账户信息
    getDouyingInfo: function(val) {
      this.$api.adPromotion
        .getDouyingInfo({
          adverId: val
        })
        .then(res => {
          // console.log(res.data);
          if (res.code === 0) {
            this.douying_options = res.data
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'error'
            })
          }
        })
      this.advertiser_options.forEach(
        function(item, index) {
          if (item.options.length > 0) {
            item.options.forEach(
              function(it, i) {
                if (it.value == val) {
                  this.project = it.project
                }
              }.bind(this)
            )
          }
        }.bind(this)
      )
    },
    // 获取商品列表
    getProductInfo: function(val) {
      this.loading = true
      var params = {
        adverId: this.advertiser_id,
        page: val ? val : 1,
        pageSize: 20,
        query: this.productQuery ? this.productQuery : ''
      }
      this.$api.adPromotion.getProductInfo(params).then(res => {
        if (res.code === 0) {
          this.productData.data = res.data.product_list
          this.productData.page = res.data.page_info.page
          this.productData.page_size = res.data.page_info.page_size
          this.productData.total_number = res.data.page_info.total_number
        }
        this.loading = false
      })
    },
    //远程搜索账户
    remoteMethodGuest: function(query) {
      this.getAdvertiserInfo(query)
    }
  },
  beforeRouteUpdate: function(to, from, next) {
    // 获取账户信息
    this.getAdvertiserInfo('')
  },
  mounted: function() {
    // console.log(this.info);
    // 获取账户信息
    this.getAdvertiserInfo('')
  }
}
</script>
<style lang="scss" scoped>
.box-eltab {
  width: 100%;
}

.k-common-con .expand-title {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 30px 0 24px;
  line-height: 56px;
  background: #fafafa;
  border: 1px solid #e8eaec;
  border-radius: 3px 3px 0 0;
}

.k-common-con .expand-title > span {
  font-size: 16px;
}

.k-common-con .expand-title {
  .panel-header-right-wrapper {
    display: flex;
  }
}

.k-common-con
  .expand-title
  .panel-header-right-wrapper
  .account-count-info-wrapper {
  display: flex;
  font-size: 12px;
  color: #999;
}

.k-common-con
  .expand-title
  .panel-header-right-wrapper
  .account-count-info-wrapper
  .ad-formula {
  display: flex;
  align-items: center;
}

.ad-formula-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
}

.ad-formula-sign {
  padding-right: 5px;
  padding-left: 5px;
  font-size: 16px;
}

.ad-formula-item__value {
  font-size: 16px;
  line-height: 18px;
}

.ad-formula-item__label {
  line-height: 18px;
}

.ad-formula-item__value.color--primary {
  color: #197afb;
}

.k-common-con .content-expand .expand-config .expand-title .collapse-icon {
  display: flex;
  align-items: center;
}

.expand-container {
  .setting-head {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px;
    background: #fff;
    border-right: 1px solid #e8eaec;
    border-left: 1px solid #e8eaec;

    .filter-selectors {
      margin-bottom: -16px;

      .selector {
        display: inline-block;
        padding-right: 16px;
        margin-bottom: 16px;
        font-size: 14px;
        color: #555;

        .k-select-area {
          margin-bottom: 0;
          margin-right: 0;
        }
      }
    }
  }

  .footer-line {
    position: relative;
    padding: 12px 24px;
    background: #fff;
    border-right: 1px solid #e8eaec;
    border-bottom: 1px solid #e8eaec;
    border-left: 1px solid #e8eaec;
    border-radius: 0 0 3px 3px;
    display: flex;
    justify-content: right;
  }

  .el-table--border,
  .el-table--group {
    border: 1px solid #ebeef5;
    border-bottom: none;
  }

  .table-wrapper .table-content .el-table__header tr:first-child th {
    height: 40px;
    color: #333;
    background-color: #fff;
  }

  .el-table th > .cell {
    display: inline-block;
    box-sizing: border-box;
    position: relative;
    vertical-align: middle;
    width: 100%;
  }

  .el-table .cell {
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    line-height: 23px;
  }

  .table-header {
    display: flex;
    align-items: center;
  }

  .table-header__number {
    margin-left: 8px;
    font-size: 12px;
    font-weight: 500;
    color: #999;
  }

  .table-header__clear {
    margin-left: auto;
    font-size: 12px;
    font-weight: 500;
    color: #999;
    cursor: pointer;

    i {
      font-size: 12px;
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      -moz-transform: rotate(45deg);
    }
  }

  .table-wrapper {
    .table-view {
      position: relative;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      height: 344px;
      padding-bottom: 44px;

      .add-view {
        position: relative;
        z-index: 10;
        height: 100%;
        padding: 12px;
        padding-bottom: 0;
        overflow: scroll;

        .no-data {
          color: #666;
        }
      }

      .el-button {
        position: absolute;
        bottom: -1px;
        left: 0;
        z-index: 10;
        display: block;
        width: 100%;
        height: 44px;
        padding: 0;
        margin: 0;
        line-height: 32px;
        color: #197afb;
        background: #fff;
        border: 0;
        border-top: 1px solid transparent;
        border-radius: 0;
      }
    }
  }

  .table-wrapper .table-content .el-table__body-wrapper .cell,
  .table-wrapper .table-content .el-table__body-wrapper td {
    padding: 0;
  }

  .table-wrapper .el-table tbody tr:hover > td {
    background-color: #ffffff !important;
  }

  .table-wrapper .table-content .el-table__header tr {
    font-size: 14px;
  }
}

.table-wrapper .el-table__body-wrapper tr td:hover .el-button {
  z-index: 12;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.08);
}

.empty-wrapper {
  margin-top: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.empty-block {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 100%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
  color: #808695;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: center;
}

.empty-wrapper .empty-block {
  height: 686px;
  border-radius: 4px;
  border: 1px dashed #dcdee2;
  background-color: #fff;
}

.empty-wrapper .empty-title {
  margin: 0 0 16px 0;
  font-size: 24px;
  color: #c3cbd6;
}

.empty-wrapper .empty-description {
  margin-top: 25px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #9ea4ad;
}

.expand-container {
  height: auto;
  overflow: hidden;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-duration: var(--animate-duration);
  animation-duration: var(--animate-duration);
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes container-show {
  0% {
    height: auto;
  }

  100% {
    height: 0;
  }
}

@keyframes container-show {
  0% {
    height: auto;
  }

  100% {
    height: 0;
  }
}

.expand-container-show {
  -webkit-animation-name: container-show;
  animation-name: container-show;
}

.detail-header {
  padding: 0 12px;
  color: #515a6e;
  border-bottom: 1px solid #ebeef5;
}

.detail-footer,
.detail-header {
  height: 32px;
  line-height: 32px;
  background-color: #f5f7fa;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.detail-body {
  padding: 12px;
  height: 305px;
  overflow: auto;
}

.detail-body-erorr {
  background: rgba(245, 108, 108, 0.1);
  border: 1px solid red;
}

.detail-footer {
  border-top: 1px solid #ebeef5;
}

.detail .btn-action {
  padding-top: 0;
  padding-bottom: 0;
  line-height: 20px;
  font-size: 14px;
  color: #007ad6;
  border: none;
  cursor: pointer;
}

.detail .btn-action:hover {
  opacity: 0.8;
}

.detail .btn-action.is-disabled {
  cursor: not-allowed;
}

.detail .el-col:not(:last-child) {
  border-right: 1px solid #ebeef5;
}

.detail .el-checkbox {
  color: #515a6e;
}

.detail .el-checkbox .el-checkbox__inner {
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.detail .el-checkbox .el-checkbox__inner:after {
  width: 4px;
  height: 8px;
}

.detail .el-checkbox .el-checkbox__label {
  padding-left: 8px;
  font-size: 12px;
}

.detail .data-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 4px;
  padding-left: 8px;
  padding-right: 8px;
  height: 24px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  background: #f8f9fd;
  font-weight: 400;
  border-radius: 4px;
  color: #007ad6;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.detail .data-item .mg-icon-close {
  cursor: pointer;
  color: #c1c6d1;
}

.kPlTable.el-table td.table-cell {
  padding: 0;
}

.kPlTable.el-table td.table-cell .cell {
  padding: 0;
}

.kPlTable.el-table tbody tr:hover > td {
  background-color: #ffffff !important;
}

.kPlTable.el-table thead.is-group tr:nth-child(1) th {
  font-size: 14px;
  font-weight: normal;
}

.kPlTable.el-table thead.is-group tr:nth-child(2) th {
  background: #fff;
  font-size: 14px;
  font-weight: bold;
}

.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.flexR {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: flex-end;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.flexL {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: left;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.el-table.kPlTable,
.el-table.kPlTable thead {
  color: #000;
}

.detail .data-item .el-icon-close {
  cursor: pointer;
}

.audience-popover {
  max-width: 650px;
  font-size: 12px;
  color: #007ad6;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kMain {
  width: 100%;
}

.panel-footer {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 24px;
  padding-right: 24px;
  height: 56px;
  background-color: #f5f7fa;
  border-radius: 0 0 4px 4px;
  border: solid #ebeef5;
  border-width: 0 1px 1px;
}

.empty-wrapper {
  margin-top: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.empty-block {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 100%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
  color: #808695;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: center;
}

.empty-wrapper .empty-block {
  height: 686px;
  border-radius: 4px;
  border: 1px dashed #dcdee2;
  background-color: #fff;
}

.empty-wrapper .empty-title {
  margin: 0 0 16px 0;
  font-size: 24px;
  color: #c3cbd6;
}

.empty-wrapper .empty-description {
  margin-top: 25px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #9ea4ad;
}

.preview-wrapper {
  background: #fff;
  margin-top: 16px;
  padding-bottom: 16px;
}

.config-adinfo {
  margin-left: 10px;
}

.kNum {
  color: #007ad6;
}

.adgroup-header {
  padding: 5px 16px 6px 16px;
  height: 40px;
  background-color: #f5f7fa;
  border: solid #ebeef5;
  border-width: 1px 1px 0;
}

.adgroup-header .account {
  font-size: 14px;
  color: #333;
  line-height: 28px;
}

.adgroup-header .account .el-checkbox {
  margin-bottom: 0;
}

.select-ad-count {
  margin-left: 16px;
  font-size: 12px;
  font-weight: 400;
  color: #007ad6;
}

.ml16 {
  margin-left: 16px;
}

.mr16 {
  margin-right: 16px;
}

.adgroup-header-info {
  color: #606266;
}

.material-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.material-group {
  margin-bottom: 16px;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  overflow: auto;
}

.material-group:last-child {
  margin-bottom: 0;
}

.material-wrapper {
  position: relative;
  margin-right: 8px;
  margin-bottom: 8px;
  width: 88px;
  height: 50px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  text-align: center;
}

.material-wrapper .material-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0;
}

.material-wrapper .material {
  max-width: 100%;
  max-height: 100%;
}

.material-wrapper .el-icon-close {
  position: absolute;
  top: 3px;
  right: 3px;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  line-height: 16px;
  opacity: 0;
}

.material-wrapper .el-icon-video-play {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 28px;
}

.formDialog .el-input {
  width: 50%;
}

.el-dialog__wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.el-dialog {
  margin: 0 auto !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

.el-dialog__body {
  max-height: 500px;
  min-height: 100px;
  overflow: auto;
}

.creative-header {
  margin-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
  height: 56px;
  line-height: 32px;
}

.creative-body {
  padding: 32px 40px;
  min-height: 360px;
  border-top: 1px solid #dcdee2;
}

.group-label {
  font-size: 14px;
  font-weight: 700;
  color: #17233d;
  line-height: 100%;
}

.group-count {
  margin-left: 16px;
  font-size: 12px;
  color: #666;
  line-height: 100%;
}

.group-info {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 2px;
  border: 1px solid #d0d0d0;
}

.creative-content {
  min-height: 300px;
  overflow: auto;
}

.creative-material .creative-group {
  position: relative;
  margin-bottom: 16px;
  border: 1px solid #d0d0d0;
  border-radius: 2px;
  line-height: 32px;
}

.creative-material .creative-group-header {
  padding: 8px 16px;
  background-color: #f5f7fa;
}

.creative-material .creative-group-name {
  color: #000;
}

.creative-material .el-icon-circle-close {
  margin-left: 8px;
  font-size: 16px;
  color: red;
  cursor: pointer;
}

.creative-material .el-icon-caret-bottom,
.creative-material .el-icon-caret-top {
  font-size: 16px;
  color: #999;
  cursor: pointer;
}

.creative-material .creative-group-body {
  position: relative;
  border-top: 1px solid #dcdee2;
}

.creative-material .creative-group-body .addBtn {
  z-index: 1;
  position: absolute;
  top: 5px;
  right: 16px;
}

.creative-material .creative-group-body .el-tabs__nav-scroll {
  padding-left: 16px;
}

.kSourceCon {
  padding: 0 16px;
  box-sizing: border-box;
  min-height: 256px;
}

.upload-container {
  display: flex;
  flex-wrap: wrap;
}

.upload-container .btn-delete {
  position: absolute;
  top: -8px;
  right: -8px;
  font-size: 16px;
  color: #2e71ea;
  cursor: pointer;
  background-color: #fff;
  border-radius: 50%;
  opacity: 0;
}

.upload-action-wrapper {
  line-height: 17px;
  margin-top: 10px;
}

.upload-action-wrapper .btn-action {
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  color: #515a6e;
  cursor: pointer;
}

.upload-action-wrapper .divider {
  margin-right: 12px;
  margin-left: 12px;
  color: #bfc4d0;
}

.upload-block {
  position: relative;
  padding: 8px;
  border: 1px solid #dcdee2;
}

.upload-wrapper {
  position: relative;
  box-sizing: border-box;
  width: 200px;
  height: 112px;
  border: 1px solid #dcdee2;
}

.upload-wrapper .img-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
}

.upload-wrapper .img-wrapper:hover .img-mask {
  opacity: 1;
}

.upload-wrapper .img-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding-right: 20px;
  padding-left: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.upload-wrapper .img-mask .btn-action {
  width: 120px;
  padding: 0;
  line-height: 22px;
  color: #fff;
}

.upload-wrapper img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}

.upload-add {
  cursor: pointer;
  border-style: dashed;
}

.upload-add .el-icon-plus {
  font-size: 32px;
  font-weight: 500;
  color: #d4d5d7;
}

.upload-wrapper-c {
  margin-right: 23px;
  margin-bottom: 16px;
  width: 200px;
}

.upload-image .upload-wrapper:hover {
  border-color: #2e71ea;
}

.upload-image .upload-wrapper:hover .el-icon-plus {
  color: #2e71ea;
}

.upload-image .upload-wrapper:hover .btn-delete {
  opacity: 1;
}

.upload-image .upload-wrapper:nth-child(4n) {
  margin-right: 0;
}

.upload-video .upload-add {
  height: 130px;
}

.upload-block-c {
  margin-right: 20px;
  margin-bottom: 16px;
}

.upload-video .upload-block {
  box-sizing: border-box;
  display: inline-flex;
}

.upload-video .upload-block:hover {
  border-color: #2e71ea;
}

.upload-video .upload-block:hover .el-icon-plus {
  color: #2e71ea;
}

.upload-video .upload-block:hover .btn-delete {
  opacity: 1;
}

.upload-video .upload-block:nth-child(2n) {
  margin-right: 0;
}

.upload-blank,
.upload-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-blank {
  flex-direction: column;
}

.pointer {
  cursor: pointer;
}

.upload-tip {
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  color: #515a6e;
  height: 34px;
  overflow: hidden;
  display: block;
  margin-top: 6px;
}

.optionSource {
  position: relative;
}

.optionSource .el-dialog__header {
  display: none;
}

.optionSource .el-dialog__body {
  padding-left: 0;
  padding-right: 0;
}

.optionSource .el-tabs__nav-scroll {
  padding-left: 16px;
}

.optionSource .el-tabs__content {
  padding: 0 16px;
}

.optionSource .el-dialog__body {
  overflow: hidden;
  max-height: none;
}

.optionSource .el-tabs__content {
  max-height: 500px;
  overflow: auto;
}

.selected-wrapper {
  position: absolute;
  top: 25px;
  right: 16px;
  z-index: 1;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #666;
}

.material .el-row {
  height: 400px;
  overflow: auto;
  margin-left: -8px;
  margin-right: -8px;
}

.material .el-col {
  padding-right: 8px;
  padding-left: 8px;
}

.material-info {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 20px;
  margin: 4px;
}

.material-item {
  position: relative;
  box-sizing: border-box;
  margin-bottom: 16px;
  font-size: 12px;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid #dcdee2;
  height: 118px;
  overflow: hidden;
}

.material-item:hover {
  border: 1px solid #007ad6;
}

.material-img {
  position: relative;
  height: 60px;
  background: no-repeat 50%;
  background-size: contain;
}

.material-name {
  overflow: hidden;
  font-weight: 700;
  color: #515a6e;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.material-other {
  position: absolute;
  right: 8px;
  bottom: 2px;
  left: 8px;
  text-align: center;
}

.material-other-item {
  font-weight: 500;
  line-height: 16px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
}

.material-desc {
  font-weight: 400;
  color: #7c8495;
}

.material-size {
  width: 80px;
}

.material-duration {
  width: 64px;
}

.material .el-checkbox {
  position: absolute;
  top: 4px;
  left: 8px;
  z-index: 1;
  border-radius: 2px;
}

.material-item .el-button--mini,
.material-item .el-button--mini.is-round {
  padding: 4px 8px;
}

.kTimeTable.el-table .cell,
.kTimeTable.el-table th div,
.kTimeTable .el-table--border td:first-child .cell,
.kTimeTable .el-table--border th:first-child .cell {
  padding-left: 0;
}

.kTimeTable.el-table .cell,
.kTimeTable.el-table th div {
  padding-right: 0;
}

.kTimeTable.el-table td,
.kTimeTable.el-table th {
  padding: 3px 0;
}

.kTimeTable .el-table__header thead > tr:nth-child(4) {
  display: none;
}

.kTimeOption {
  border: 1px solid #ebeef5;
  padding: 5px 10px 10px;
  border-top: none;
  font-size: 12px;
  line-height: 24px;
}

.kTimeClear {
  color: #197afb;
}

.k-table-toolbar {
  margin-top: 8px;
}

.k-table-toolbar {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background-color: #fff;
  border: 1px solid #e8eaec;
  border-bottom: 0 none;
}

.k-selected {
  font-size: 12px;
  color: #666;
}

.k-selected .num {
  color: #197afb;
}

.targeting .el-dialog__body {
  max-height: 100%;
}

.timeSelectTable {
  height: 90%;
  max-height: 100%;
}

.timeSelectTable .el-dialog__body {
  max-height: 100%;
}

.kSourceConV2 {
  padding: 0 16px 16px;
  box-sizing: border-box;
  min-height: 256px;
}

.kSourceConV2Tips {
  font-size: 12px;
}

.kSourceConV2Body {
  display: flex;
  flex-wrap: wrap;
}

.kSourceConV2Body .upload-wrapper {
  margin: 8px 8px 0 0;
}

.upload-wrapper-video {
  display: inline-flex;
  margin: 8px 8px 0 0;
  position: relative;
  box-sizing: border-box;
  width: 400px;
  height: 112px;
  border: 1px solid #dcdee2;
}

.targeting
  .el-dialog__body
  .el-table
  .el-table__header-wrapper
  table
  thead
  tr:nth-child(1)
  th {
  background: #f5f7fa;
}

.adGroupInfor .el-divider--horizontal {
  margin: 10px 0;
}

.kEmoBox {
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  background: #fff;
  overflow: hidden;
  padding: 5px 0;
}

.kEmoBox .el-image {
  padding: 4px;
  border-radius: 4px;
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  float: left;
}

.kEmoBox .el-image:hover {
  background: #f5f7fa;
}

.kEmo {
  position: relative;
}

.kEmo .k-icon-emo {
  font-size: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 4px;
  display: inline-block;
  margin-bottom: 8px;
}

.detail-body-fix {
  overflow: hidden;
  position: relative;
}

.kdetailHeader {
  height: 40px;
}

.kdetailBody {
  height: 360px;
  overflow: auto;
}

.kdetailFooter {
  height: 50px;
}

.kSourceGroup {
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
  display: flex;
}

.kSourceGroupCon {
  background-color: #fff;
  display: inline-flex;
  position: relative;
  width: 60px;
  height: 60px;
  box-sizing: border-box;
  padding: 3px;
  border: 1px solid #ebeef5;
  border-radius: 3px;
}

.kSourceGroupCon div {
  width: 52px;
  height: 52px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.kSourceGroupCon:nth-child(1) {
  z-index: 3;
}

.kSourceGroupCon:nth-child(2) {
  z-index: 2;
  left: -30px;
}

.kSourceGroupCon:nth-child(3) {
  z-index: 1;
  left: -60px;
}

.kSourceGroupCon:nth-child(2) div:after,
.kSourceGroupCon:nth-child(3) div:after {
  content: '';
  display: block;
  width: 52px;
  height: 52px;
  background-color: #000;
  opacity: 0.5;
  position: absolute;
  left: 3px;
  top: 3px;
}

.kSourceGroupCon:nth-child(2) div:after {
  opacity: 0.3;
}

.kShadow {
  -moz-box-shadow: 6px 0px 7px rgba(227, 231, 232, 0.35);
  -webkit-box-shadow: 6px 0px 7px rgba(227, 231, 232, 0.35);
  box-shadow: 6px 0px 7px rgba(227, 231, 232, 0.35);
}

.kSourceGroupPiont {
  align-items: center;
  display: inline-flex;
  width: 50px;
  height: 60px;
  line-height: 60px;
}

.kSourceGroupPiont span {
  position: relative;
  right: 35px;
  width: 3px;
  height: 3px;
  background-color: #c0c4cc;
  border-radius: 50%;
  display: inline-flex;
  margin-left: 3px;
}

.kupload-con {
  margin-top: 10px;
  position: relative;
  width: auto;
  height: 112px;
  overflow: hidden;
  border: 1px solid #dcdee2;
}

.kupload-con-img {
  display: inline-flex;
  width: 100%;
}

.kupload-con-imgcen {
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
  width: 200px;
  height: 110px;
  justify-content: center;
  display: inline-flex;
  align-items: center;
}

.kupload-con-imgcen:after {
  content: '';
  display: block;
  width: 1px;
  height: 80px;
  position: absolute;
  right: 0;
  top: 15px;
  background-color: #dcdee2;
}

.kupload-con-imgcen:last-child::after {
  opacity: 0;
}

.kupload-con:hover .img-mask {
  opacity: 1;
}

.kupload-con .img-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding-right: 20px;
  padding-left: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.kupload-con .img-mask .btn-action {
  width: 120px;
  padding: 0;
  line-height: 22px;
  color: #fff;
}

.kupload-con-imgcen img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}

.SourceDialogV2 {
  height: 90%;
}

.SourceDialogV2 .el-dialog__body {
  max-height: 800px;
  height: calc(100% - 85px);
  padding: 0 16px;
}

.kSourceBox {
  display: flex;
  height: 100%;
  justify-content: space-between;
}

.kSourceItem {
  width: calc(46% - 38px);
  height: 100%;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
}

.kSourceItemTop {
  background: #f5f7fa;
}

.kSourceItemTop p {
  border-bottom: 1px solid #dcdfe6;
  font-size: 12px;
  color: #606266;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  position: relative;
}

.kSourceItemTop-add {
  position: absolute;
  right: 10px;
  top: 6px;
}

.kSourceItemTop p b {
  font-weight: bold;
  color: #000;
}

.kSourceItemTop p:nth-child(1) {
  line-height: 41px;
}

.kSourceItemTop p:nth-child(1) b {
  font-size: 14px;
}

.kSourceItemTop p:nth-child(2) {
  line-height: 22px;
  padding: 5px 16px;
}

.kSourceItemCon {
  width: 100%;
  height: calc(100% - 76px);
  overflow-y: auto;
}

.kSourceIcon {
  background: url(../../assets/images/sourceicon.jpg) no-repeat center center;
  width: 76px;
  height: 100%;
}

.kItems {
  border-bottom: 1px solid #dcdfe6;
}

.kItems.hov {
  border: 1px solid #409eff;
}

.kItemsTitle {
  font-size: 14px;
  font-weight: bold;
  color: #000;
  position: relative;
  height: 40;
  line-height: 40px;
  border-bottom: 1px solid #dcdfe6;
  padding: 0 16px;
  box-sizing: border-box;
}

.kItemsTitle > span {
  font-size: 12px;
  font-weight: normal;
  margin-left: 10px;
}

.kItemsTitle i {
  position: absolute;
  color: #fe444b;
  right: 12px;
  top: 12px;
  cursor: pointer;
  font-weight: normal;
  font-size: 16px;
}

.kItemsCon {
  padding: 16px 5px;
  box-sizing: border-box;
  min-height: 130px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.kItemsCon .kItemsConImg {
  position: relative;
  border: 1px solid #f1f2f4;
  width: 100px;
  height: 52px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.kItemsCon .kItemsConImg a {
  width: 100%;
  height: 52px;
  display: inline-flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}

.kItemsCon .kItemsConImg:hover {
  border-color: #007ad6;
}

.kItemsCon .kItemsConImg:hover:before {
  width: 100%;
  height: 100%;
  background: rgba(0, 122, 214, 0.1);
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
}

.kItemsCon .kItemsConImg img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}

.kItemsCon i {
  width: 16px;
  height: 16px;
  background: url(/static/images/delicon.png) no-repeat center;
  display: none;
  position: absolute;
  right: -8px;
  top: -8px;
  font-size: 16px;
  color: #f25643;
  z-index: 2;
  cursor: pointer;
}

.kItemsCon .kItemsConImg:hover i {
  display: block;
}

.kItemsConVideo {
  position: relative;
  border: 1px solid #f1f2f4;
  width: 260px;
  height: 87px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin: 5px;
}

.kItemsConVideo:before {
  content: '';
  display: block;
  width: 1px;
  height: 80%;
  top: 10%;
  left: 50%;
  background: #f1f2f4;
  position: absolute;
}

.kItemsConVideoC {
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
  width: 130px;
  height: 85px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.kItemsConVideoC a,
.kItemsConVideoC div {
  width: 100%;
  height: 85px;
  display: inline-flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}

.kItemsConVideoC a img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}

.kNullCover {
  display: inline-flex;
  align-content: center;
  flex-wrap: wrap;
}

.kNullCover p {
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #c3cbd6;
  padding-top: 2px;
}

.kItemsConVideo i {
  width: 16px;
  height: 16px;
  background: url(../../assets/images/delicon.png) no-repeat center;
  display: block;
  position: absolute;
  right: -8px;
  top: -8px;
  font-size: 16px;
  color: #f25643;
  z-index: 2;
  cursor: pointer;
}

.kItemsCon .kItemsConVideo:hover i {
  display: block;
}

.kItemsCon .kItemsConVideo:hover {
  border-color: #007ad6;
}

.kSourceDepot {
  width: calc(54% - 38px);
  height: 100%;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
}

.kSourceDepot h4 {
  font-size: 14px;
  font-weight: bold;
  color: #000;
  position: relative;
  height: 41px;
  line-height: 41px;
  border-bottom: 1px solid #dcdfe6;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  background: #f5f7fa;
}

.kSourceDepot h4 p {
  color: #606266;
  font-size: 12px;
  font-weight: normal;
}

.kDepotSearch {
  padding: 8px 16px 0;
}

.kDepotSearch .el-form-item--mini.el-form-item,
.kDepotSearch .el-form-item--small.el-form-item {
  margin-bottom: 8px;
}

.material {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  height: calc(100% - 50px);
  align-content: flex-start;
}

.material .material-item {
  width: 110px;
  margin-left: 16px;
}

.kDepotCon {
  height: 100%;
  margin-top: 8px;
  position: relative;
  overflow: hidden;
}

.kDepotCon .el-pagination {
  position: absolute;
  bottom: 3px;
}

.kItemsNull {
  text-align: center;
  color: #c3cbd6;
  font-size: 12px;
  width: 100%;
}

.kItemsNull img {
  display: inline-block;
}

.kVideoDetail {
  line-height: 24px;
  font-size: 12px;
  color: #000;
}

.kVideoDetailT {
  background: #fafbfc;
  padding: 10px 16px;
}

.kVideoDetailB {
  padding: 0 16px;
  margin-top: 5px;
}

.kVideoDetail h5 {
  font-weight: bold;
  padding: 6px 0 4px;
  font-size: 12px;
  color: #000;
}

.SourceDialogVideo .el-dialog__body {
  padding: 0;
}

.SourceDialogVideo {
  width: 340px;
}

.kVideoDetail video {
  width: 100%;
}

.kVideoDetailB div {
  width: 200px;
  height: 120px;
  overflow: hidden;
  border: 1px solid #f1f2f4;
  display: flex;
  justify-content: center;
  align-items: center;
}

.kVideoDetailB div img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}

.kVideoDetailB p {
  padding: 5px 0 15px;
}

.SourceDialogVideo .el-dialog__header {
  padding: 11px 16px 6px;
  background: #f5f7fa;
  border-bottom: 1px solid #dcdfe6;
}

.SourceDialogVideo .el-dialog__title {
  font-size: 14px;
  font-weight: bold;
}

.SourceDialogVideo .el-dialog__headerbtn {
  top: 10px;
}

.SourceDialogVideo .el-dialog__body {
  max-height: 600px;
}

.table-wrapper .table-view .add-view .add-line {
  height: 100%;
  line-height: 18px;
}

.table-wrapper .table-view .add-view .add-line .add-title {
  margin-top: 4px;
  font-size: 12px;
  color: #666;
}

.table-wrapper .table-view .add-view .add-line .add-title span {
  font-size: 12px;
}

.k-drawer .el-drawer__body {
  overflow: auto;
}

.k-product-img {
  width: 100%;
  display: flex;
}

.k-product-img dt {
  width: 100px;
  height: 100px;
}

.k-product-img dd {
  padding-left: 10px;
}

.promotion_card_wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.promotion_card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 400px;
  background-color: #f0f0f0;
  border-radius: 4px;
  padding: 10px;
}

.collapse-btn {
  margin-left: 20px;
  color: #197afb;
  cursor: pointer;
}

.promotion_card__left {
  display: flex;
  align-items: center;
  line-height: 20px;
}

.promotion_card__right {
  width: 70px;
  height: 22px;
  line-height: 22px;
  color: #fff;
  text-align: center;
  background-color: #ed5085;
  border-radius: 3px;
  font-size: 12px;
}

.promotion_card__left__desc {
  font-size: 12px;
}

.promotion_card__left__selling {
  width: 200px;
  overflow: hidden;
  font-size: 12px;
  color: #999;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kTimeTable.el-table .cell,
.kTimeTable.el-table th div {
  padding-right: 0 !important;
}

.kTimeTable.el-table .cell,
.kTimeTable.el-table th div,
.kTimeTable .el-table--border td:first-child .cell,
.kTimeTable .el-table--border th:first-child .cell {
  padding-left: 0 !important;
}
</style>
<style>
.adver
  .k-page-common
  .k-common-con
  .el-table
  .el-table__body-wrapper
  .el-table__cell {
  padding: 0 !important;
}

.adver
  .k-page-common
  .k-common-con
  .el-table
  .el-table__body-wrapper
  .el-table__cell
  .cell {
  padding: 0;
}

.adver .table-wrapper .el-table tbody tr:hover > td {
  background-color: #ffffff !important;
}
</style>
